<template>
  <div class="result" :class="{ 'is-loaded': isLoaded }">
    <Loading class="result_loading" />
    <!-- 結果表示上部 -->
    <div v-if="getLanguage == '日本語'">
      <section class="result_top">
        <h2 class="result_topTtl">診断結果</h2>
        <div class="result_topIn">
          <div class="result_summary">
            <div>
              <h3 class="result_dev">
                <span class="result_devTtl">あなたの偏差値</span>
                <span class="result_devTxt">{{
                  this.deviationValue.toFixed(1)
                }}</span>
              </h3>
            </div>
            <div>
              <div class="result_devGraph">
                <div class="result_devDesc">
                  <h3 class="result_devGraphDesc1">偏差値分布グラフ</h3>
                  <p class="result_devGraphDesc2">
                    あなたがいる位置を表示しています
                  </p>
                </div>
                <div class="result_devGraphCont">
                  <apexchart
                    height="200"
                    class="result_chart"
                    type="bar"
                    :options="chartOptions"
                    :series="series"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>
          <div class="result_rank">
            <div class="result_rankIn">
              <p class="result_score">
                <span class="result_scoreIndex">
                  <span class="result_scoreIndexTxt">スコア</span>
                </span>
                <span class="result_scoreCont">
                  <span class="result_scoreTtl">合計</span>
                  <span class="result_scoreNum">{{
                    Math.round(this.scoreTotal)
                  }}</span>
                  <span class="result_scoreSuffix">点</span>
                  <span class="result_scoreSlash">／</span>
                  <span class="result_scoreAllNum">100</span>
                  <span class="result_scoreAllSuffix">点中</span>
                </span>
              </p>
              <p class="result_rankTxt">
                <span class="result_rankCategory">
                  <span class="result_rankCategoryTxt">順 位</span>
                </span>
                <span class="result_rankCont">
                  <span class="result_rankTtl">全国</span>
                  <span class="result_rankNum">{{ totalScoreRank }}</span>
                  <span class="result_rankSuffix">位</span>
                  <span class="result_rankSlash">／</span>
                  <span class="result_populationNum">{{ rankPopulation }}</span>
                  <span class="result_populationSuffix">人中</span>
                </span>
              </p>
            </div>
          </div>
          <div class="result_advice">
            <div class="result_adviceImg">
              <img src="/img/illust_drNishino.svg" alt="" />
            </div>
            <div class="result_adviceCont">
              <p class="result_adviser">
                <span class="result_adviserSub"
                  >スタンフォード大学医学部 教授</span
                >
                <span class="result_adviserTtl"
                  >西野 精治<span class="result_adviserTtlSm">先生監修の</span
                  >アドバイス</span
                >
              </p>
              <p class="result_adviceTxt">
                {{ advices.summary[hasSleepDisorder][devIndex] }}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- 日本語ver -->

    <div v-if="getLanguage == 'English'">
      <section class="result_top">
        <h2 class="result_topTtl">Diagnostic Results</h2>
        <div class="result_topIn">
          <div class="result_summary">
            <div>
              <h3 class="result_dev">
                <span class="result_devTtl">Your Deviation Score</span>
                <span class="result_devTxt">{{
                  this.deviationValue.toFixed(1)
                }}</span>
              </h3>
            </div>
            <div>
              <div class="result_devGraph">
                <div class="result_devDesc">
                  <h3 class="result_devGraphDesc1">
                    Sleep deviation distribution graph
                  </h3>
                  <p class="result_devGraphDesc2">
                    It shows the position you are in
                  </p>
                </div>
                <div class="result_devGraphCont">
                  <apexchart
                    height="200"
                    class="result_chart"
                    type="bar"
                    :options="chartOptions"
                    :series="series"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>
          <div class="result_rank">
            <div class="result_rankIn">
              <p class="result_score">
                <span class="result_scoreIndex">
                  <span class="result_scoreIndexTxt">Score</span>
                </span>
                <span class="result_scoreCont">
                  <span class="result_scoreTtl">Total</span>
                  <span class="result_scoreNum">{{
                    Math.round(this.scoreTotal)
                  }}</span>
                  <span class="result_scoreSlash">／</span>
                  <span class="result_scoreAllNum">100</span>
                  <span class="result_scoreAllSuffix">points</span>
                </span>
              </p>
              <p class="result_rankTxt">
                <span class="result_rankCategory">
                  <span class="result_rankCategoryTxt">Rank</span>
                </span>
                <span class="result_rankCont">
                  <span class="result_rankTtl">Nation-wide</span>
                  <span class="result_rankNum">{{
                    ordinal(totalScoreRank)
                  }}</span>
                  <span class="result_rankSlash">／</span>
                  <span class="result_populationSuffix"> out of </span
                  ><span class="result_populationNum">{{
                    rankPopulation
                  }}</span>
                </span>
              </p>
            </div>
          </div>
          <div class="result_advice">
            <div class="result_adviceImg">
              <img src="/img/illust_drNishino.svg" alt="" />
            </div>
            <div class="result_adviceCont">
              <p class="result_adviser">
                <span class="result_adviserSub"
                  >Professor, Stanford University, School of Medicine</span
                >
                <span class="result_adviserTtl"
                  >Advice supervised by Dr. Seiji Nishino</span
                >
              </p>
              <p class="result_adviceTxt">
                {{ advices.summary[hasSleepDisorder][devIndex] }}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- 英語ver -->

    <div v-if="getLanguage == '中文'">
      <section class="result_top">
        <h2 class="result_topTtl">诊断结果</h2>
        <div class="result_topIn">
          <div class="result_summary">
            <div>
              <h3 class="result_dev">
                <span class="result_devTtl">您的偏差值</span>
                <span class="result_devTxt">{{
                  this.deviationValue.toFixed(1)
                }}</span>
              </h3>
            </div>
            <div>
              <div class="result_devGraph">
                <div class="result_devDesc">
                  <h3 class="result_devGraphDesc1">偏差值分布图</h3>
                  <p class="result_devGraphDesc2">显示您所处的位置。</p>
                </div>
                <div class="result_devGraphCont">
                  <apexchart
                    height="200"
                    class="result_chart"
                    type="bar"
                    :options="chartOptions"
                    :series="series"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>
          <div class="result_rank">
            <div class="result_rankIn">
              <p class="result_score">
                <span class="result_scoreIndex">
                  <span class="result_scoreIndexTxt">分数</span>
                </span>
                <span class="result_scoreCont">
                  <span class="result_scoreTtl">总分</span>
                  <span class="result_scoreNum"
                    >{{ Math.round(this.scoreTotal) }}分</span
                  >
                  <span class="result_scoreSlash">／</span>
                  <span class="result_scoreAllNum">满分100分</span>
                </span>
              </p>
              <p class="result_rankTxt">
                <span class="result_rankCategory">
                  <span class="result_rankCategoryTxt">排名</span>
                </span>
                <span class="result_rankCont">
                  <span class="result_rankTtl">全国</span>
                  <span class="result_rankNum">第{{ totalScoreRank }}名</span>
                  <span class="result_rankSlash">／</span>
                  <span class="result_populationNum">{{ rankPopulation }}</span>
                  <span class="result_populationSuffix">名</span>
                </span>
              </p>
            </div>
          </div>
          <div class="result_advice">
            <div class="result_adviceImg">
              <img src="/img/illust_drNishino.svg" alt="" />
            </div>
            <div class="result_adviceCont">
              <p class="result_adviser">
                <span class="result_adviserSub">斯坦福大学医学院教授</span>
                <span class="result_adviserTtl">西野精治博士指导的建议</span>
              </p>
              <p class="result_adviceTxt">
                {{ advices.summary[hasSleepDisorder][devIndex] }}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- 中文ver -->

    <!-- レポート詳細 -->
    <div v-if="getLanguage == '日本語'">
      <section class="result_detail">
        <h3 class="result_detailTtl">項目別の結果</h3>
        <div class="result_detailIn">
          <div class="result_rankingExplanation">
            <p>各項目の判定区分</p>
            <ul class="result_rankingList">
              <li class="result_rankingListItem">
                <div class="rankingRank result_rankingRank-A">
                  <span class="result_rankingRankTxt">A</span>
                </div>
                <div class="result_rankingText">
                  <span>課題なし</span>
                </div>
              </li>
              <li class="result_rankingListItem">
                <div class="rankingRank result_rankingRank-B">
                  <span class="result_rankingRankTxt">B</span>
                </div>
                <div class="result_rankingText">
                  <span>軽度な課題あり</span>
                </div>
              </li>
              <li class="result_rankingListItem">
                <div class="rankingRank result_rankingRank-C">
                  <span class="result_rankingRankTxt">C</span>
                </div>
                <div class="result_rankingText">
                  <span>課題あり</span>
                </div>
              </li>
              <li class="result_rankingListItem">
                <div class="rankingRank result_rankingRank-D">
                  <span class="result_rankingRankTxt">D</span>
                </div>
                <div class="result_rankingText">
                  <span>要改善</span>
                </div>
              </li>
            </ul>
          </div>
          <ul class="result_detailList">
            <li class="result_detailListItem">
              <dl
                class="result_detailRank"
                :class="'result_detailRank-' + sleepQualityRank"
              >
                <dt class="result_detailRankTtl">
                  <span class="result_detailRankTtlTxt">睡眠の質</span>
                </dt>
                <dd class="result_detailRankData">
                  <span class="result_detailRankTxt">{{
                    sleepQualityRank
                  }}</span>
                  <span class="result_detailRanking">{{
                    returnSleepQualityDesc
                  }}</span>
                  <span class="result_detailRanking"
                    >{{ sleepQualityRanking }}位／{{ rankPopulation }}人中</span
                  >
                </dd>
              </dl>
              <div class="result_detailDesc">
                <p class="result_detailDescTxt">
                  {{ advices.sleepQuality[sleepQualityRank] }}
                </p>
              </div>
              <div class="result_detailSub">
                <div>
                  <p>
                    <span class="result_detailSubTtl">あなたの平均睡眠時間</span
                    ><span class="result_detailSubCont"
                      >{{ parseInt(sleepTime / 60) }}時間{{
                        sleepTime % 60
                      }}分</span
                    ><span class="result_detailSubDif"
                      >全国平均 {{ sleepTimeDifference }}分</span
                    >
                  </p>
                </div>
              </div>
            </li>
            <li class="result_detailListItem result_detailListItem-SAS">
              <dl
                class="result_detailRank"
                :class="'result_detailRank-' + sasRiskRank"
              >
                <dt class="result_detailRankTtl">
                  <span class="result_detailRankTtlTxt">SASリスク</span>
                </dt>
                <dd class="result_detailRankData">
                  <span class="result_detailRankTxt">{{ sasRiskRank }}</span>
                  <span class="result_detailRanking">{{
                    sasRiskRankDescVarible
                  }}</span>
                  <span class="result_detailRanking"
                    >{{ sasRiskRanking }}位／{{ rankPopulation }}人中</span
                  >
                </dd>
              </dl>
              <div class="result_detail-sas">
                <div class="result_sas">
                  <div class="result_detailDesc">
                    <p class="result_detailDescTxt">
                      {{ advices.sasRisk[sasRiskRank] }}
                    </p>
                    <p
                      class="result_detailDescTxt"
                      v-if="hasSleepDisorder == 1 && hasSas == 1"
                    >
                      {{ advices.sasRisk.hasSleepDisorder }}
                    </p>
                  </div>
                  <div class="result_detailSub noBg result_detailSub-sas">
                    <img src="/img/illust_sas.svg" alt="" />
                  </div>
                </div>
                <div class="result_detailDescSASBlock">
                  <div class="result_detailDescSAS">
                    <p class="result_detailDescSASTtl">
                      SASリスクがC・Dランクだった方へ
                    </p>
                    <p class="result_detailDescSASTxt">
                      西野が外来顧問を務める睡眠時無呼吸症候群のクリニックはオンラインでの診療が可能です。ぜひ、専門家へ相談してみてください。
                    </p>
                  </div>
                  <div class="result_detailDescSASLink">
                    <img
                      src="@/assets/img_sasclinic.jpg"
                      srcset="
                        @/assets/img_sasclinic.jpg    1x,
                        @/assets/img_sasclinic@2x.jpg 2x
                      "
                      alt="Dクリニック ウェルネス"
                      class="result_detailDescSASClinicImg"
                    />
                    <p class="result_detailDescSASClinic">
                      <span class="result_detailDescSASClinicName"
                        >Dクリニック ウェルネス</span
                      >
                      <span class="result_detailDescSASClinicSAS"
                        >睡眠・SAS外来</span
                      >
                      <span class="result_detailDescSASClinicOnline"
                        >オンライン可</span
                      >
                      <a
                        href="https://www.sumahoshin.or.jp/"
                        target="_blank"
                        class="result_detailDescSASClinicLink"
                      >
                        WEBサイトはこちら
                      </a>
                    </p>
                  </div>
                  <div class="result_detailDesc">
                    <p class="result_detailDescSub">
                      {{ advices.sasRisk["All"] }}
                    </p>
                  </div>
                  <div class="result_detailDesc">
                    <p class="result_detailDescSub">
                      {{ advices.sasRisk["All"] }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="result_detailSub result_detailSub-sas2 noBg">
                <img src="/img/illust_sas.svg" alt="" />
              </div>
            </li>
            <li class="result_detailListItem">
              <dl
                class="result_detailRank"
                :class="'result_detailRank-' + productivityRank"
              >
                <dt class="result_detailRankTtl">
                  <span class="result_detailRankTtlTxt">生産性</span>
                </dt>
                <dd class="result_detailRankData">
                  <span class="result_detailRankTxt">{{
                    productivityRank
                  }}</span>
                  <span class="result_detailRanking">{{
                    productivityRankDescVarible
                  }}</span>
                  <span class="result_detailRanking"
                    >{{ productivityRanking }}位／{{ rankPopulation }}人中</span
                  >
                </dd>
              </dl>
              <div class="result_detailDesc">
                <p class="result_detailDescTxt">
                  {{ advices.productivity[productivityRank] }}
                </p>
              </div>
              <div class="result_detailSub">
                <div>
                  <p>
                    <span class="result_detailSubTtl"
                      ><span>あなたの生産性低下による経済損失額は</span></span
                    >
                  </p>
                  <p>
                    <span class="result_detailSubCont"
                      >年間{{ EconomicLoss }}万円</span
                    >
                  </p>
                </div>
              </div>
            </li>
            <li class="result_detailListItem">
              <dl
                class="result_detailRank"
                :class="'result_detailRank-' + daytimeSleepnessRank"
              >
                <dt class="result_detailRankTtl">
                  <span class="result_detailRankTtlTxt">日中の眠気</span>
                </dt>
                <dd class="result_detailRankData">
                  <span class="result_detailRankTxt">{{
                    daytimeSleepnessRank
                  }}</span>
                  <span class="result_detailRanking">{{
                    dayTimeSleepnessRankDescVarible
                  }}</span>
                  <span class="result_detailRanking"
                    >{{ daytimeSleepnessRanking }}位／{{
                      rankPopulation
                    }}人中</span
                  >
                </dd>
              </dl>
              <div class="result_detailDesc">
                <p class="result_detailDescTxt">
                  {{
                    advices.daytimeSleepness[hasSleepDisorder][
                      daytimeSleepnessRank
                    ]
                  }}
                </p>
              </div>
              <div class="result_detailSub">
                <div>
                  <p>
                    <span class="result_detailSubTtl"
                      >あなたが日中<br />眠気を感じる時間</span
                    ><span class="result_detailSubCont"
                      >{{ sleepnessTime }}時間/週</span
                    >
                  </p>
                  <p>
                    <span class="result_detailSubDif"
                      >全国平均 {{ sleepnessTimeDiffernce }}時間</span
                    >
                  </p>
                </div>
              </div>
            </li>
            <li class="result_detailListItem">
              <dl
                class="result_detailRank"
                :class="'result_detailRank-' + motivationRank"
              >
                <dt class="result_detailRankTtl">
                  <span class="result_detailRankTtlTxt"
                    >ストレス<br />モチベーション</span
                  >
                </dt>
                <dd class="result_detailRankData">
                  <span class="result_detailRankTxt">{{ motivationRank }}</span>
                  <span class="result_detailRanking">{{
                    motivationRankDescVarible
                  }}</span>
                  <span class="result_detailRanking"
                    >{{ motivationRanking }}位／{{ rankPopulation }}人中</span
                  >
                </dd>
              </dl>
              <div class="result_detailDesc">
                <p class="result_detailDescTxt">
                  {{ advices.motivation[motivationRank] }}
                </p>
                <p class="result_detailDescTxt" v-if="isShortSleeper == 1">
                  {{ advices.motivation.isShortSleeper }}
                </p>
              </div>
              <div class="result_detailSub noBg">
                <img src="/img/illust_work.svg" alt="" />
              </div>
            </li>
          </ul>
        </div>
      </section>
    </div>

    <div v-if="getLanguage == 'English'">
      <section class="result_detail">
        <h3 class="result_detailTtl">Results by item</h3>
        <div class="result_detailIn">
          <div class="result_rankingExplanation">
            <p>Judgment category for each item</p>
            <ul class="result_rankingList">
              <li class="result_rankingListItem">
                <div class="rankingRank result_rankingRank-A">
                  <span class="result_rankingRankTxt">A</span>
                </div>
                <div class="result_rankingText">
                  <span>No issues</span>
                </div>
              </li>
              <li class="result_rankingListItem">
                <div class="rankingRank result_rankingRank-B">
                  <span class="result_rankingRankTxt">B</span>
                </div>
                <div class="result_rankingText">
                  <span>Some minor issues</span>
                </div>
              </li>
              <li class="result_rankingListItem">
                <div class="rankingRank result_rankingRank-C">
                  <span class="result_rankingRankTxt">C</span>
                </div>
                <div class="result_rankingText">
                  <span>There is an issue</span>
                </div>
              </li>
              <li class="result_rankingListItem">
                <div class="rankingRank result_rankingRank-D">
                  <span class="result_rankingRankTxt">D</span>
                </div>
                <div class="result_rankingText">
                  <span>Needs Improvement</span>
                </div>
              </li>
            </ul>
          </div>
          <ul class="result_detailList">
            <li class="result_detailListItem">
              <dl
                class="result_detailRank"
                :class="'result_detailRank-' + sleepQualityRank"
              >
                <dt class="result_detailRankTtl">
                  <span class="result_detailRankTtlTxt">Sleep quality</span>
                </dt>
                <dd class="result_detailRankData">
                  <span class="result_detailRankTxt">{{
                    sleepQualityRank
                  }}</span>
                  <span class="result_detailRanking">{{
                    returnSleepQualityDesc
                  }}</span>
                  <span class="result_detailRanking"
                    >{{ ordinal(sleepQualityRanking) }} ／out of
                    {{ rankPopulation }}</span
                  >
                </dd>
              </dl>
              <div class="result_detailDesc">
                <p class="result_detailDescTxt">
                  {{ advices.sleepQuality[sleepQualityRank] }}
                </p>
              </div>
              <div class="result_detailSub">
                <div>
                  <p>
                    <span class="result_detailSubTtl"
                      >Your average sleep time</span
                    ><span class="result_detailSubCont"
                      >{{ parseInt(sleepTime / 60) }} hour <br />{{
                        sleepTime % 60
                      }}
                      minutes</span
                    ><span class="result_detailSubDif"
                      >National average {{ sleepTimeDifference }}minutes</span
                    >
                  </p>
                </div>
              </div>
            </li>
            <li class="result_detailListItem">
              <dl
                class="result_detailRank"
                :class="'result_detailRank-' + sasRiskRank"
              >
                <dt class="result_detailRankTtl">
                  <span class="result_detailRankTtlTxt">SAS risk</span>
                </dt>
                <dd class="result_detailRankData">
                  <span class="result_detailRankTxt">{{ sasRiskRank }}</span>
                  <span class="result_detailRanking">{{
                    sasRiskRankDescVarible
                  }}</span>
                  <span class="result_detailRanking"
                    >{{ ordinal(sasRiskRanking) }} ／out of
                    {{ rankPopulation }}</span
                  >
                </dd>
              </dl>
              <div class="result_detailDesc">
                <div class="result_detailDesc">
                  <p class="result_detailDescSub">
                    {{ advices.sasRisk["All"] }}
                  </p>
                </div>
                <div class="result_sas">
                  <div class="result_detailDesc">
                    <p class="result_detailDescTxt">
                      {{ advices.sasRisk[sasRiskRank] }}
                    </p>
                    <p
                      class="result_detailDescTxt"
                      v-if="hasSleepDisorder == 1 && hasSas == 1"
                    >
                      {{ advices.sasRisk.hasSleepDisorder }}
                    </p>
                  </div>
                  <div class="result_detailSub noBg result_detailSub-sas">
                    <img src="/img/illust_sas.svg" alt="" />
                  </div>
                </div>
              </div>
              <div class="result_detailSub result_detailSub-sas2 noBg">
                <img src="/img/illust_sas.svg" alt="" />
              </div>
            </li>
            <li class="result_detailListItem">
              <dl
                class="result_detailRank"
                :class="'result_detailRank-' + productivityRank"
              >
                <dt class="result_detailRankTtl">
                  <span class="result_detailRankTtlTxt">Productivity</span>
                </dt>
                <dd class="result_detailRankData">
                  <span class="result_detailRankTxt">{{
                    productivityRank
                  }}</span>
                  <span class="result_detailRanking">{{
                    productivityRankDescVarible
                  }}</span>
                  <span class="result_detailRanking"
                    >{{ ordinal(productivityRanking) }} ／out of
                    {{ rankPopulation }}</span
                  >
                </dd>
              </dl>
              <div class="result_detailDesc">
                <p class="result_detailDescTxt">
                  {{ advices.productivity[productivityRank] }}
                </p>
              </div>
              <div class="result_detailSub">
                <div>
                  <p>
                    <span class="result_detailSubTtl"
                      ><span
                        >The amount of economic loss due to your lost
                        productivity is</span
                      ></span
                    >
                  </p>
                  <p>
                    <span class="result_detailSubCont"
                      >JPY {{ EconomicLoss / 100 }} million per year</span
                    >
                  </p>
                </div>
              </div>
            </li>
            <li class="result_detailListItem">
              <dl
                class="result_detailRank"
                :class="'result_detailRank-' + daytimeSleepnessRank"
              >
                <dt class="result_detailRankTtl">
                  <span class="result_detailRankTtlTxt"
                    >Daytime sleepiness</span
                  >
                </dt>
                <dd class="result_detailRankData">
                  <span class="result_detailRankTxt">{{
                    daytimeSleepnessRank
                  }}</span>
                  <span class="result_detailRanking">{{
                    dayTimeSleepnessRankDescVarible
                  }}</span>
                  <span class="result_detailRanking"
                    >{{ ordinal(daytimeSleepnessRanking) }} ／out of
                    {{ rankPopulation }}</span
                  >
                </dd>
              </dl>
              <div class="result_detailDesc">
                <p class="result_detailDescTxt">
                  {{
                    advices.daytimeSleepness[hasSleepDisorder][
                      daytimeSleepnessRank
                    ]
                  }}
                </p>
              </div>
              <div class="result_detailSub">
                <div>
                  <p>
                    <span class="result_detailSubTtl"
                      >The time you feel sleepy during the day</span
                    ><span class="result_detailSubCont"
                      >{{ sleepnessTime }} hours/week</span
                    >
                  </p>
                  <p>
                    <span class="result_detailSubDif"
                      >National average <br />{{
                        sleepnessTimeDiffernce
                      }}
                      hours</span
                    >
                  </p>
                </div>
              </div>
            </li>
            <li class="result_detailListItem">
              <dl
                class="result_detailRank"
                :class="'result_detailRank-' + motivationRank"
              >
                <dt class="result_detailRankTtl">
                  <span class="result_detailRankTtlTxt"
                    >Stress<br />Motivation</span
                  >
                </dt>
                <dd class="result_detailRankData">
                  <span class="result_detailRankTxt">{{ motivationRank }}</span>
                  <span class="result_detailRanking">{{
                    motivationRankDescVarible
                  }}</span>
                  <span class="result_detailRanking"
                    >{{ ordinal(motivationRanking) }}／out of
                    {{ rankPopulation }}</span
                  >
                </dd>
              </dl>
              <div class="result_detailDesc">
                <p class="result_detailDescTxt">
                  {{ advices.motivation[motivationRank] }}
                </p>
                <p class="result_detailDescTxt" v-if="isShortSleeper == 1">
                  {{ advices.motivation.isShortSleeper }}
                </p>
              </div>
              <div class="result_detailSub noBg">
                <img src="/img/illust_work.svg" alt="" />
              </div>
            </li>
          </ul>
        </div>
      </section>
    </div>
    <!-- 英語ver  -->
    <div v-if="getLanguage == '中文'">
      <section class="result_detail">
        <h3 class="result_detailTtl">按项目分列的结果</h3>
        <div class="result_detailIn">
          <div class="result_rankingExplanation">
            <p>每个项目的判断分类</p>
            <ul class="result_rankingList">
              <li class="result_rankingListItem">
                <div class="rankingRank result_rankingRank-A">
                  <span class="result_rankingRankTxt">A</span>
                </div>
                <div class="result_rankingText">
                  <span>没问题</span>
                </div>
              </li>
              <li class="result_rankingListItem">
                <div class="rankingRank result_rankingRank-B">
                  <span class="result_rankingRankTxt">B</span>
                </div>
                <div class="result_rankingText">
                  <span>轻度问题</span>
                </div>
              </li>
              <li class="result_rankingListItem">
                <div class="rankingRank result_rankingRank-C">
                  <span class="result_rankingRankTxt">C</span>
                </div>
                <div class="result_rankingText">
                  <span>有问题</span>
                </div>
              </li>
              <li class="result_rankingListItem">
                <div class="rankingRank result_rankingRank-D">
                  <span class="result_rankingRankTxt">D</span>
                </div>
                <div class="result_rankingText">
                  <span>需要改进</span>
                </div>
              </li>
            </ul>
          </div>
          <ul class="result_detailList">
            <li class="result_detailListItem">
              <dl
                class="result_detailRank"
                :class="'result_detailRank-' + sleepQualityRank"
              >
                <dt class="result_detailRankTtl">
                  <span class="result_detailRankTtlTxt">睡眠质量</span>
                </dt>
                <dd class="result_detailRankData">
                  <span class="result_detailRankTxt">{{
                    sleepQualityRank
                  }}</span>
                  <span class="result_detailRanking">{{
                    sleepQualityRankDescVarible
                  }}</span>
                  <span class="result_detailRanking"
                    >第{{ sleepQualityRanking }}名 ／{{
                      rankPopulation
                    }}名</span
                  >
                </dd>
              </dl>
              <div class="result_detailDesc">
                <p class="result_detailDescTxt">
                  {{ advices.sleepQuality[sleepQualityRank] }}
                </p>
              </div>
              <div class="result_detailSub">
                <div>
                  <p>
                    <span class="result_detailSubTtl">平均睡眠时间</span
                    ><span class="result_detailSubCont"
                      >{{ parseInt(sleepTime / 60) }} 小时 <br />{{
                        sleepTime % 60
                      }}
                      分钟</span
                    ><span class="result_detailSubDif"
                      >全国平均 {{ sleepTimeDifference }}分钟</span
                    >
                  </p>
                </div>
              </div>
            </li>
            <li class="result_detailListItem">
              <dl
                class="result_detailRank"
                :class="'result_detailRank-' + sasRiskRank"
              >
                <dt class="result_detailRankTtl">
                  <span class="result_detailRankTtlTxt">SAS风险</span>
                </dt>
                <dd class="result_detailRankData">
                  <span class="result_detailRankTxt">{{ sasRiskRank }}</span>
                  <span class="result_detailRanking">{{
                    sasRiskRankDescVarible
                  }}</span>
                  <span class="result_detailRanking"
                    >第{{ sasRiskRanking }}名 ／{{ rankPopulation }}名</span
                  >
                </dd>
              </dl>
              <div class="result_detailDesc">
                <div class="result_detailDesc">
                  <p class="result_detailDescSub">
                    {{ advices.sasRisk["All"] }}
                  </p>
                </div>
                <div class="result_sas">
                  <div class="result_detailDesc">
                    <p class="result_detailDescTxt">
                      {{ advices.sasRisk[sasRiskRank] }}
                    </p>
                    <p
                      class="result_detailDescTxt"
                      v-if="hasSleepDisorder == 1 && hasSas == 1"
                    >
                      {{ advices.sasRisk.hasSleepDisorder }}
                    </p>
                  </div>
                  <div class="result_detailSub noBg result_detailSub-sas">
                    <img src="/img/illust_sas.svg" alt="" />
                  </div>
                </div>
              </div>
              <div class="result_detailSub result_detailSub-sas2 noBg">
                <img src="/img/illust_sas.svg" alt="" />
              </div>
            </li>
            <li class="result_detailListItem">
              <dl
                class="result_detailRank"
                :class="'result_detailRank-' + productivityRank"
              >
                <dt class="result_detailRankTtl">
                  <span class="result_detailRankTtlTxt">生产率</span>
                </dt>
                <dd class="result_detailRankData">
                  <span class="result_detailRankTxt">{{
                    productivityRank
                  }}</span>
                  <span class="result_detailRanking">{{
                    productivityRankDescVarible
                  }}</span>
                  <span class="result_detailRanking"
                    >第{{ productivityRanking }}名 ／{{
                      rankPopulation
                    }}名</span
                  >
                </dd>
              </dl>
              <div class="result_detailDesc">
                <p class="result_detailDescTxt">
                  {{ advices.productivity[productivityRank] }}
                </p>
              </div>
              <div class="result_detailSub">
                <div>
                  <p>
                    <span class="result_detailSubTtl"
                      ><span
                        >由于你的生产力降低而造成的经济损失金额为</span
                      ></span
                    >
                  </p>
                  <p>
                    <span class="result_detailSubCont"
                      >每年{{ EconomicLoss / 10 }}万日元</span
                    >
                  </p>
                </div>
              </div>
            </li>
            <li class="result_detailListItem">
              <dl
                class="result_detailRank"
                :class="'result_detailRank-' + daytimeSleepnessRank"
              >
                <dt class="result_detailRankTtl">
                  <span class="result_detailRankTtlTxt">白天嗜睡</span>
                </dt>
                <dd class="result_detailRankData">
                  <span class="result_detailRankTxt">{{
                    daytimeSleepnessRank
                  }}</span>
                  <span class="result_detailRanking">{{
                    dayTimeSleepnessRankDescVarible
                  }}</span>
                  <span class="result_detailRanking"
                    >第{{ daytimeSleepnessRanking }}名 ／{{
                      rankPopulation
                    }}名</span
                  >
                </dd>
              </dl>
              <div class="result_detailDesc">
                <p class="result_detailDescTxt">
                  {{
                    advices.daytimeSleepness[hasSleepDisorder][
                      daytimeSleepnessRank
                    ]
                  }}
                </p>
              </div>
              <div class="result_detailSub">
                <div>
                  <p>
                    <span class="result_detailSubTtl">白天感到困倦的时间</span
                    ><span class="result_detailSubCont"
                      >{{ sleepnessTime }} 小时/周</span
                    >
                  </p>
                  <p>
                    <span class="result_detailSubDif"
                      >全国平均 <br />{{ sleepnessTimeDiffernce }} 小时</span
                    >
                  </p>
                </div>
              </div>
            </li>
            <li class="result_detailListItem">
              <dl
                class="result_detailRank"
                :class="'result_detailRank-' + motivationRank"
              >
                <dt class="result_detailRankTtl">
                  <span class="result_detailRankTtlTxt">压力动机</span>
                </dt>
                <dd class="result_detailRankData">
                  <span class="result_detailRankTxt">{{ motivationRank }}</span>
                  <span class="result_detailRanking">{{
                    motivationRankDescVarible
                  }}</span>
                  <span class="result_detailRanking"
                    >第{{ motivationRanking }}名／{{ rankPopulation }}名</span
                  >
                </dd>
              </dl>
              <div class="result_detailDesc">
                <p class="result_detailDescTxt">
                  {{ advices.motivation[motivationRank] }}
                </p>
                <p class="result_detailDescTxt" v-if="isShortSleeper == 1">
                  {{ advices.motivation.isShortSleeper }}
                </p>
              </div>
              <div class="result_detailSub noBg">
                <img src="/img/illust_work.svg" alt="" />
              </div>
            </li>
          </ul>
        </div>
      </section>
    </div>
    <!-- 中文ver -->

    <!-- 外部リンク誘導 -->
    <div v-if="getLanguage == '日本語'">
      <section class="result_articles">
        <h2 class="result_articlesTtl">より良い睡眠のために</h2>
        <!-- <h3 class="result_articlesSubTtl">
          各界の専門家による睡眠の質向上動画
        </h3>
        <ul class="result_articlesList">
          <li class="result_article">
            <a
              v-bind:href="getLoginUserInfo['report_end_url']"
              class="result_articleLink"
              target="_blank"
            >
              <div class="result_articleThumb">
                <img src="../assets/sp_article_1.jpg" alt="" />
              </div>
              <p class="result_articleTxt">
                <span class="result_articleTtl">
                  {{ getLoginUserInfo["report_end_url"] }}</span
                >
              </p>
            </a>
          </li>
        </ul> -->
        <div>
          <h3 class="result_articlesSubTtl">最高の睡眠を導くためのポイント</h3>
          <ul class="result_articlesList">
            <li class="result_article">
              <a
                href="https://brain-sleep.com/news/magazine/sleep-improvement/"
                class="result_articleLink"
                target="_blank"
              >
                <div class="result_articleThumb">
                  <img src="../assets/sp_article_1.jpg" alt="" />
                </div>
                <p class="result_articleTxt">
                  <span class="result_articleTtl"
                    >最初の90分が肝心！<br />ノンレム睡眠を深くする睡眠術！</span
                  >
                </p>
              </a>
            </li>
            <li class="result_article">
              <a
                href="https://brain-sleep.com/news/magazine/merit7/"
                class="result_articleLink"
                target="_blank"
              >
                <div class="result_articleThumb">
                  <img src="../assets/sp_article_2.jpg" alt="" />
                </div>
                <p class="result_articleTxt">
                  <span class="result_articleTtl"
                    >意外と知らない睡眠の<br />メリット7選</span
                  >
                </p>
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h3 class="result_articlesSubTtl">睡眠の質をあげるためのポイント</h3>
          <ul class="result_articlesList">
            <li class="result_article">
              <a
                href="https://brain-sleep.com/news/magazine/sleep-method-all/"
                class="result_articleLink"
                target="_blank"
              >
                <div class="result_articleThumb">
                  <img src="../assets/sp_article_3.jpg" alt="" />
                </div>
                <p class="result_articleTxt">
                  <span class="result_articleTtl">最高の睡眠の10ヶ条</span>
                </p>
              </a>
            </li>
            <li class="result_article">
              <a
                href="https://brain-sleep.com/news/magazine/rhythm-disorder/"
                class="result_articleLink"
                target="_blank"
              >
                <div class="result_articleThumb">
                  <img src="../assets/sp_article_4.jpg" alt="" />
                </div>
                <p class="result_articleTxt">
                  <span class="result_articleTtl">生活リズムの治し方</span>
                </p>
              </a>
            </li>
            <li class="result_article">
              <a
                href="https://brain-sleep.com/news/magazine/sleep-method8/"
                class="result_articleLink"
                target="_blank"
              >
                <div class="result_articleThumb">
                  <img src="../assets/sp_article_5.jpg" alt="" />
                </div>
                <p class="result_articleTxt">
                  <span class="result_articleTtl"
                    >ブルーライトを避けるべき理由</span
                  >
                </p>
              </a>
            </li>
            <li class="result_article">
              <a
                href="https://brain-sleep.com/news/magazine/sleep-method7?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
                class="result_articleLink"
                target="_blank"
              >
                <div class="result_articleThumb">
                  <img src="../assets/sp_article_6.jpg" alt="" />
                </div>
                <p class="result_articleTxt">
                  <span class="result_articleTtl"
                    >就寝90分前に入浴のススメ</span
                  >
                </p>
              </a>
            </li>
            <li class="result_article">
              <a
                href="https://brain-sleep.com/news/magazine/sleep-method1/"
                class="result_articleLink"
                target="_blank"
              >
                <div class="result_articleThumb">
                  <img src="../assets/sp_article_7.jpg" alt="" />
                </div>
                <p class="result_articleTxt">
                  <span class="result_articleTtl"
                    >アラームは2段階で設定する</span
                  >
                </p>
              </a>
            </li>
            <li class="result_article">
              <a
                href="https://brain-sleep.com/news/magazine/alcohol/"
                class="result_articleLink"
                target="_blank"
              >
                <div class="result_articleThumb">
                  <img src="../assets/sp_article_8.jpg" alt="" />
                </div>
                <p class="result_articleTxt">
                  <span class="result_articleTtl"
                    >お酒との上手な付き合い方</span
                  >
                </p>
              </a>
            </li>
          </ul>
        </div>
        <div class="article-group">
          <div class="article-pair">
            <h3 class="result_articlesSubTtl left half">
              睡眠時無呼吸症候群（SAS)とは？
            </h3>
            <ul class="result_articlesList half left">
              <li class="result_article">
                <a
                  href="https://brain-sleep.com/news/magazine/snoring-and-apnea/"
                  class="result_articleLink"
                  target="_blank"
                >
                  <div class="result_articleThumb">
                    <img src="../assets/sp_article_9.jpg" alt="" />
                  </div>
                  <p class="result_articleTxt">
                    <span class="result_articleTtl"
                      >睡眠時無呼吸症候群の原因や<br />治療法徹底解説！</span
                    >
                  </p>
                </a>
              </li>
            </ul>
          </div>
          <div class="article-pair">
            <h3 class="result_articlesSubTtl right half">
              睡眠薬との上手な付き合い方
            </h3>
            <ul class="result_articlesList half right">
              <li class="result_article">
                <a
                  href="https://brain-sleep.com/news/magazine/sleeping-pills1/"
                  class="result_articleLink"
                  target="_blank"
                >
                  <div class="result_articleThumb">
                    <img src="../assets/sp_article_10.jpg" alt="" />
                  </div>
                  <p class="result_articleTxt">
                    <span class="result_articleTtl"
                      >睡眠薬の種類、使い方や選び方<br />などの上手な付き合い方とは</span
                    >
                  </p>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <h3 class="result_articlesSubTtl">生産性に効果ある睡眠術</h3>
          <ul class="result_articlesList">
            <li class="result_article">
              <a
                href="https://brain-sleep.com/news/magazine/nap?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
                class="result_articleLink"
                target="_blank"
              >
                <div class="result_articleThumb">
                  <img src="../assets/sp_article_11.jpg" alt="" />
                </div>
                <p class="result_articleTxt">
                  <span class="result_articleTtl">最大効果の仮眠とは</span>
                </p>
              </a>
            </li>
            <li class="result_article">
              <a
                href="https://brain-sleep.com/news/magazine/short-sleeper?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
                class="result_articleLink"
                target="_blank"
              >
                <div class="result_articleThumb">
                  <img src="../assets/sp_article_12.jpg" alt="" />
                </div>
                <p class="result_articleTxt">
                  <span class="result_articleTtl"
                    >偉人の睡眠はちょっと違う！</span
                  >
                </p>
              </a>
            </li>
          </ul>
        </div>
        <div class="article-group">
          <div class="article-pair">
            <h3 class="result_articlesSubTtl left half">日中の眠気対策</h3>
            <ul class="result_articlesList half left">
              <li class="result_article">
                <a
                  href="https://brain-sleep.com/news/magazine/sleepiness/"
                  class="result_articleLink"
                  target="_blank"
                >
                  <div class="result_articleThumb">
                    <img src="../assets/sp_article_13.jpg" alt="" />
                  </div>
                  <p class="result_articleTxt">
                    <span class="result_articleTtl"
                      >瞬時に眠気を飛ばす方法9選</span
                    >
                  </p>
                </a>
              </li>
            </ul>
          </div>
          <div class="article-pair">
            <h3 class="result_articlesSubTtl right half">
              睡眠×ストレス・モチベーション対策
            </h3>
            <ul class="result_articlesList half right">
              <li class="result_article">
                <a
                  href="https://brain-sleep.com/news/magazine/mental-stress/"
                  class="result_articleLink"
                  target="_blank"
                >
                  <div class="result_articleThumb">
                    <img src="../assets/sp_article_14.jpg" alt="" />
                  </div>
                  <p class="result_articleTxt">
                    <span class="result_articleTtl"
                      >緊張で眠れないあなたへ</span
                    >
                  </p>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <!-- 代理店プラン差し込みエリア -->
        <a v-on:click="toSleepTestPath">
          <div
            v-if="getLoginUserInfo.report_end_url == '表示する'"
            class="result_articlesLink_pr"
          >
            <p class="result_articlesLinkTtl_pr">
              <v-icon large color="grey darken-2">mdi-sleep</v-icon
              >睡眠改善コンテンツ
            </p>
            <p class="result_articlesLinkTxt_pr">
              心身の健康と睡眠をテーマにした改善コンテンツです
            </p>
          </div>
        </a>
        <!-- ここまで -->
        <div class="result_articlesLink">
          <p class="result_articlesLinkTtl">
            睡眠対策方法や睡眠情報をもっと知りたい方は
          </p>
          <p class="result_articlesLinkTxt">
            <a
              class="result_articlesLinkHref"
              href="https://brain-sleep.com/news/magazine/"
              target="_blank"
              ><img
                src="../assets/magagine.png"
                alt="SleepediA"
                class="result_articlesLinkImg"
            /></a>
          </p>
        </div>
        <div class="result_articlesLink">
          <p class="result_articlesLinkTtl">
            最高のぐっすりがみつかる、眠りのランドマーク
          </p>
          <p
            class="result_articlesLinkTxt"
            id="brain_sleep_store_image"
            style="padding-left: 52px;"
          >
            <a
              style="@media screen and (min-width: 1024px) {padding-left: 60px}"
              class="result_articlesLinkHref"
              href="https://www.zzz-land.com/shop/default.aspx"
              target="_blank"
              ><img
                src="../assets/store_bg.png"
                alt="ZZZLand"
                class="result_articlesLinkImg"
            /></a>
          </p>
        </div>
        <!-- 任意のリンク表示エリア -->
        <a
          v-on:click="toSleepLinkPath"
          v-if="
            getLoginUserInfo.report_end_link_url != '' &&
              getLoginUserInfo.report_end_link_text != '' &&
              getLoginUserInfo.report_end_link_url != null &&
              getLoginUserInfo.report_end_link_text != null
          "
        >
          <div class="result_articlesLink_pr" style="height:130px">
            <p class="result_articlesLinkTtl_pr">
              <v-icon large color="grey darken-2">mdi-open-in-new</v-icon>
              <span>{{ this.getLoginUserInfo.report_end_link_text }}</span>
            </p>
          </div>
        </a>
      </section>
    </div>
    <!-- 日本語ver -->

    <div v-if="getLanguage == 'English'">
      <section class="result_articles">
        <h2 class="result_articlesTtl">For a better sleep</h2>
        <h2 class="result_articlesTtl">
          *The following article is written in Japanese
        </h2>
        <h3 class="result_articlesSubTtl">The key to the best sleep</h3>
        <ul class="result_articlesList">
          <li class="result_article">
            <a
              href="https://sleepedia.jp/sleep-improvement/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
              class="result_articleLink"
              target="_blank"
            >
              <div class="result_articleThumb">
                <img src="../assets/sp_article_1.jpg" alt="" />
              </div>
              <p class="result_articleTxt">
                <span class="result_articleTtl"
                  >最初の90分が肝心！<br />ノンレム睡眠を深くする睡眠術！</span
                >
              </p>
            </a>
          </li>
          <li class="result_article">
            <a
              href="https://sleepedia.jp/merit7/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
              class="result_articleLink"
              target="_blank"
            >
              <div class="result_articleThumb">
                <img src="../assets/sp_article_2.jpg" alt="" />
              </div>
              <p class="result_articleTxt">
                <span class="result_articleTtl"
                  >意外と知らない睡眠の<br />メリット7選</span
                >
              </p>
            </a>
          </li>
        </ul>
        <h3 class="result_articlesSubTtl">The key to getting a good sleep</h3>
        <ul class="result_articlesList">
          <li class="result_article">
            <a
              href="https://sleepedia.jp/sleep-method-all/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
              class="result_articleLink"
              target="_blank"
            >
              <div class="result_articleThumb">
                <img src="../assets/sp_article_3.jpg" alt="" />
              </div>
              <p class="result_articleTxt">
                <span class="result_articleTtl">最高の睡眠の10ヶ条</span>
              </p>
            </a>
          </li>
          <li class="result_article">
            <a
              href="https://sleepedia.jp/rhythm-disorder/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
              class="result_articleLink"
              target="_blank"
            >
              <div class="result_articleThumb">
                <img src="../assets/sp_article_4.jpg" alt="" />
              </div>
              <p class="result_articleTxt">
                <span class="result_articleTtl">生活リズムの治し方</span>
              </p>
            </a>
          </li>
          <li class="result_article">
            <a
              href="https://sleepedia.jp/sleep-method8/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
              class="result_articleLink"
              target="_blank"
            >
              <div class="result_articleThumb">
                <img src="../assets/sp_article_5.jpg" alt="" />
              </div>
              <p class="result_articleTxt">
                <span class="result_articleTtl"
                  >ブルーライトを避けるべき理由</span
                >
              </p>
            </a>
          </li>
          <li class="result_article">
            <a
              href="https://brain-sleep.com/news/magazine/sleep-method7?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
              class="result_articleLink"
              target="_blank"
            >
              <div class="result_articleThumb">
                <img src="../assets/sp_article_6.jpg" alt="" />
              </div>
              <p class="result_articleTxt">
                <span class="result_articleTtl">就寝90分前に入浴のススメ</span>
              </p>
            </a>
          </li>
          <li class="result_article">
            <a
              href="https://sleepedia.jp/sleep-method1/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
              class="result_articleLink"
              target="_blank"
            >
              <div class="result_articleThumb">
                <img src="../assets/sp_article_7.jpg" alt="" />
              </div>
              <p class="result_articleTxt">
                <span class="result_articleTtl">アラームは2段階で設定する</span>
              </p>
            </a>
          </li>
          <li class="result_article">
            <a
              href="https://sleepedia.jp/alcohol/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
              class="result_articleLink"
              target="_blank"
            >
              <div class="result_articleThumb">
                <img src="../assets/sp_article_8.jpg" alt="" />
              </div>
              <p class="result_articleTxt">
                <span class="result_articleTtl">お酒との上手な付き合い方</span>
              </p>
            </a>
          </li>
        </ul>
        <div class="article-group">
          <div class="article-pair">
            <h3 class="result_articlesSubTtl left half">
              What is Sleep Apnea Syndrome (SAS)?
            </h3>
            <ul class="result_articlesList half left">
              <li class="result_article">
                <a
                  href="https://sleepedia.jp/apnea-syndrome/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
                  class="result_articleLink"
                  target="_blank"
                >
                  <div class="result_articleThumb">
                    <img src="../assets/sp_article_9.jpg" alt="" />
                  </div>
                  <p class="result_articleTxt">
                    <span class="result_articleTtl"
                      >睡眠時無呼吸症候群の原因や<br />治療法徹底解説！</span
                    >
                  </p>
                </a>
              </li>
            </ul>
          </div>
          <div class="article-pair">
            <h3 class="result_articlesSubTtl right half">
              How to get along with sleeping pills
            </h3>
            <ul class="result_articlesList half right">
              <li class="result_article">
                <a
                  href="https://sleepedia.jp/sleeping-pills1/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
                  class="result_articleLink"
                  target="_blank"
                >
                  <div class="result_articleThumb">
                    <img src="../assets/sp_article_10.jpg" alt="" />
                  </div>
                  <p class="result_articleTxt">
                    <span class="result_articleTtl"
                      >睡眠薬の種類、使い方や選び方<br />などの上手な付き合い方とは</span
                    >
                  </p>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <h3 class="result_articlesSubTtl">
          How to sleep effectively for productivity
        </h3>
        <ul class="result_articlesList">
          <li class="result_article">
            <a
              href="https://brain-sleep.com/news/magazine/nap?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
              class="result_articleLink"
              target="_blank"
            >
              <div class="result_articleThumb">
                <img src="../assets/sp_article_11.jpg" alt="" />
              </div>
              <p class="result_articleTxt">
                <span class="result_articleTtl">最大効果の仮眠とは</span>
              </p>
            </a>
          </li>
          <li class="result_article">
            <a
              href="https://brain-sleep.com/news/magazine/short-sleeper?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
              class="result_articleLink"
              target="_blank"
            >
              <div class="result_articleThumb">
                <img src="../assets/sp_article_12.jpg" alt="" />
              </div>
              <p class="result_articleTxt">
                <span class="result_articleTtl"
                  >偉人の睡眠はちょっと違う！</span
                >
              </p>
            </a>
          </li>
        </ul>
        <div class="article-group">
          <div class="article-pair">
            <h3 class="result_articlesSubTtl left half">
              Measures against daytime sleepiness
            </h3>
            <ul class="result_articlesList half left">
              <li class="result_article">
                <a
                  href="https://sleepedia.jp/sleepiness/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
                  class="result_articleLink"
                  target="_blank"
                >
                  <div class="result_articleThumb">
                    <img src="../assets/sp_article_13.jpg" alt="" />
                  </div>
                  <p class="result_articleTxt">
                    <span class="result_articleTtl"
                      >瞬時に眠気を飛ばす方法9選</span
                    >
                  </p>
                </a>
              </li>
            </ul>
          </div>
          <div class="article-pair">
            <h3 class="result_articlesSubTtl right half">
              Sleep x Stress and Motivation Measures
            </h3>
            <ul class="result_articlesList half right">
              <li class="result_article">
                <a
                  href="https://sleepedia.jp/mental-stress/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
                  class="result_articleLink"
                  target="_blank"
                >
                  <div class="result_articleThumb">
                    <img src="../assets/sp_article_14.jpg" alt="" />
                  </div>
                  <p class="result_articleTxt">
                    <span class="result_articleTtl"
                      >緊張で眠れないあなたへ</span
                    >
                  </p>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="result_articlesLink">
          <p class="result_articlesLinkTtl">
            If you want to know more about sleep strategies and sleep
            information
          </p>
          <p class="result_articlesLinkTxt">
            <a
              class="result_articlesLinkHref"
              href="https://sleepedia.jp/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
              target="_blank"
              ><img
                src="../assets/sp_logo@2x.png"
                alt="SleepediA"
                class="result_articlesLinkImg"
            /></a>
          </p>
        </div>
        <div class="result_articlesLink">
          <p class="result_articlesLinkTtl">
            A landmark of sleep where you can find your best night's sleep
          </p>
          <p class="result_articlesLinkTxt">
            <a
              style="@media screen and (min-width: 1024px) {padding-left: 60px}"
              class="result_articlesLinkHref"
              href="https://www.zzz-land.com/shop/default.aspx"
              target="_blank"
              ><img
                style="width: 155px !important"
                src="../assets/logo_zzzland.png"
                alt="ZZZLand"
                class="result_articlesLinkImg"
            /></a>
          </p>
        </div>
      </section>
    </div>
    <!-- 英語ver -->

    <div v-if="getLanguage == '中文'">
      <section class="result_articles">
        <h2 class="result_articlesTtl">为了更好的睡眠</h2>
        <h2 class="result_articlesTtl">※下面的文章是用日语写的。</h2>
        <p class="result_articlesSubTtl">帮助你获得最佳睡眠的要点</p>
        <ul class="result_articlesList">
          <li class="result_article">
            <a
              href="https://sleepedia.jp/sleep-improvement/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
              class="result_articleLink"
              target="_blank"
            >
              <div class="result_articleThumb">
                <img src="../assets/sp_article_1.jpg" alt="" />
              </div>
              <p class="result_articleTxt">
                <span class="result_articleTtl"
                  >最初の90分が肝心！<br />ノンレム睡眠を深くする睡眠術！</span
                >
              </p>
            </a>
          </li>
          <li class="result_article">
            <a
              href="https://sleepedia.jp/merit7/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
              class="result_articleLink"
              target="_blank"
            >
              <div class="result_articleThumb">
                <img src="../assets/sp_article_2.jpg" alt="" />
              </div>
              <p class="result_articleTxt">
                <span class="result_articleTtl"
                  >意外と知らない睡眠の<br />メリット7選</span
                >
              </p>
            </a>
          </li>
        </ul>
        <h3 class="result_articlesSubTtl">提高睡眠质量的要点</h3>
        <ul class="result_articlesList">
          <li class="result_article">
            <a
              href="https://sleepedia.jp/sleep-method-all/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
              class="result_articleLink"
              target="_blank"
            >
              <div class="result_articleThumb">
                <img src="../assets/sp_article_3.jpg" alt="" />
              </div>
              <p class="result_articleTxt">
                <span class="result_articleTtl">最高の睡眠の10ヶ条</span>
              </p>
            </a>
          </li>
          <li class="result_article">
            <a
              href="https://sleepedia.jp/rhythm-disorder/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
              class="result_articleLink"
              target="_blank"
            >
              <div class="result_articleThumb">
                <img src="../assets/sp_article_4.jpg" alt="" />
              </div>
              <p class="result_articleTxt">
                <span class="result_articleTtl">生活リズムの治し方</span>
              </p>
            </a>
          </li>
          <li class="result_article">
            <a
              href="https://sleepedia.jp/sleep-method8/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
              class="result_articleLink"
              target="_blank"
            >
              <div class="result_articleThumb">
                <img src="../assets/sp_article_5.jpg" alt="" />
              </div>
              <p class="result_articleTxt">
                <span class="result_articleTtl"
                  >ブルーライトを避けるべき理由</span
                >
              </p>
            </a>
          </li>
          <li class="result_article">
            <a
              href="https://brain-sleep.com/news/magazine/sleep-method7?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
              class="result_articleLink"
              target="_blank"
            >
              <div class="result_articleThumb">
                <img src="../assets/sp_article_6.jpg" alt="" />
              </div>
              <p class="result_articleTxt">
                <span class="result_articleTtl">就寝90分前に入浴のススメ</span>
              </p>
            </a>
          </li>
          <li class="result_article">
            <a
              href="https://sleepedia.jp/sleep-method1/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
              class="result_articleLink"
              target="_blank"
            >
              <div class="result_articleThumb">
                <img src="../assets/sp_article_7.jpg" alt="" />
              </div>
              <p class="result_articleTxt">
                <span class="result_articleTtl">アラームは2段階で設定する</span>
              </p>
            </a>
          </li>
          <li class="result_article">
            <a
              href="https://sleepedia.jp/alcohol/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
              class="result_articleLink"
              target="_blank"
            >
              <div class="result_articleThumb">
                <img src="../assets/sp_article_8.jpg" alt="" />
              </div>
              <p class="result_articleTxt">
                <span class="result_articleTtl">お酒との上手な付き合い方</span>
              </p>
            </a>
          </li>
        </ul>
        <div class="article-group">
          <div class="article-pair">
            <h3 class="result_articlesSubTtl left half">
              什么是睡眠呼吸暂停综合症（SAS）？
            </h3>
            <ul class="result_articlesList half left">
              <li class="result_article">
                <a
                  href="https://sleepedia.jp/apnea-syndrome/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
                  class="result_articleLink"
                  target="_blank"
                >
                  <div class="result_articleThumb">
                    <img src="../assets/sp_article_9.jpg" alt="" />
                  </div>
                  <p class="result_articleTxt">
                    <span class="result_articleTtl"
                      >睡眠時無呼吸症候群の原因や<br />治療法徹底解説！</span
                    >
                  </p>
                </a>
              </li>
            </ul>
          </div>
          <div class="article-pair">
            <h3 class="result_articlesSubTtl right half">
              安眠药怎么吃效果最好
            </h3>
            <ul class="result_articlesList half right">
              <li class="result_article">
                <a
                  href="https://sleepedia.jp/sleeping-pills1/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
                  class="result_articleLink"
                  target="_blank"
                >
                  <div class="result_articleThumb">
                    <img src="../assets/sp_article_10.jpg" alt="" />
                  </div>
                  <p class="result_articleTxt">
                    <span class="result_articleTtl"
                      >睡眠薬の種類、使い方や選び方<br />などの上手な付き合い方とは</span
                    >
                  </p>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <h3 class="result_articlesSubTtl">有效的睡眠技巧提高工作效率</h3>
        <ul class="result_articlesList">
          <li class="result_article">
            <a
              href="https://brain-sleep.com/news/magazine/nap?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
              class="result_articleLink"
              target="_blank"
            >
              <div class="result_articleThumb">
                <img src="../assets/sp_article_11.jpg" alt="" />
              </div>
              <p class="result_articleTxt">
                <span class="result_articleTtl">最大効果の仮眠とは</span>
              </p>
            </a>
          </li>
          <li class="result_article">
            <a
              href="https://brain-sleep.com/news/magazine/short-sleeper?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
              class="result_articleLink"
              target="_blank"
            >
              <div class="result_articleThumb">
                <img src="../assets/sp_article_12.jpg" alt="" />
              </div>
              <p class="result_articleTxt">
                <span class="result_articleTtl"
                  >偉人の睡眠はちょっと違う！</span
                >
              </p>
            </a>
          </li>
        </ul>
        <div class="article-group">
          <div class="article-pair">
            <h3 class="result_articlesSubTtl left half">预防白天嗜睡的措施</h3>
            <ul class="result_articlesList half left">
              <li class="result_article">
                <a
                  href="https://sleepedia.jp/sleepiness/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
                  class="result_articleLink"
                  target="_blank"
                >
                  <div class="result_articleThumb">
                    <img src="../assets/sp_article_13.jpg" alt="" />
                  </div>
                  <p class="result_articleTxt">
                    <span class="result_articleTtl"
                      >瞬時に眠気を飛ばす方法9選</span
                    >
                  </p>
                </a>
              </li>
            </ul>
          </div>
          <div class="article-pair">
            <h3 class="result_articlesSubTtl right half">
              睡眠x压力和动机的措施
            </h3>
            <ul class="result_articlesList half right">
              <li class="result_article">
                <a
                  href="https://sleepedia.jp/mental-stress/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
                  class="result_articleLink"
                  target="_blank"
                >
                  <div class="result_articleThumb">
                    <img src="../assets/sp_article_14.jpg" alt="" />
                  </div>
                  <p class="result_articleTxt">
                    <span class="result_articleTtl"
                      >緊張で眠れないあなたへ</span
                    >
                  </p>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="result_articlesLink">
          <p class="result_articlesLinkTtl">
            推荐给想了解更多关于睡眠措施和睡眠信息的人
          </p>
          <p class="result_articlesLinkTxt">
            <a
              class="result_articlesLinkHref"
              href="https://sleepedia.jp/?utm_source=hensachi&utm_medium=slpdia_owned&utm_campaign=sh"
              target="_blank"
              ><img
                src="../assets/sp_logo@2x.png"
                alt="SleepediA"
                class="result_articlesLinkImg"
            /></a>
          </p>
        </div>
        <div class="result_articlesLink">
          <p class="result_articlesLinkTtl">
            睡眠的地标，在这里你可以找到最好的睡眠。
          </p>
          <p class="result_articlesLinkTxt">
            <a
              style="@media screen and (min-width: 1024px) {padding-left: 60px}"
              class="result_articlesLinkHref"
              href="https://www.zzz-land.com/shop/default.aspx"
              target="_blank"
              ><img
                style="width: 155px !important"
                src="../assets/logo_zzzland.png"
                alt="ZZZLand"
                class="result_articlesLinkImg"
            /></a>
          </p>
        </div>
      </section>
    </div>
    <!-- 中文ver -->

    <div v-if="getLanguage == '日本語'">
      <footer class="footer">
        <div class="footer_in">
          <div class="footer_1">
            <p>
              <span class="footer_serviceTtl">睡眠偏差値® for Biz</span>
              <span class="footer_serviceUrl">suiminhensachi.com</span>
            </p>
          </div>
          <div class="footer_2">
            <ul class="footer_nav">
              <li class="footer_navItem" v-on:click="toTermPath">
                <a>利用規約</a>
              </li>
            </ul>
          </div>
          <div class="footer_3">
            <dl>
              <dt>運営会社</dt>
              <dd>
                <a href="https://brain-sleep.com/"
                  ><img
                    src="../assets/bs-logo-company.png"
                    class="footer_bslogoImg"
                    alt="BRAIN SLEEP"
                /></a>
              </dd>
            </dl>
          </div>
        </div>
      </footer>
    </div>
    <!-- 日本語ver -->
    <div v-if="getLanguage == 'English'">
      <footer class="footer">
        <div class="footer_in">
          <div class="footer_1">
            <p>
              <span class="footer_serviceTtl">睡眠偏差値® for Biz</span>
              <span class="footer_serviceUrl">suiminhensachi.com</span>
            </p>
          </div>
          <div class="footer_2">
            <ul class="footer_nav">
              <li class="footer_navItem" v-on:click="toTermPath">
                <a>Terms of service</a>
              </li>
            </ul>
          </div>
          <div class="footer_3">
            <dl>
              <dt>Operating Company</dt>
              <dd>
                <a href="https://brain-sleep.com/"
                  ><img
                    src="../assets/bs_logo.svg"
                    class="footer_bslogoImg"
                    alt="BRAIN SLEEP"
                /></a>
              </dd>
            </dl>
          </div>
        </div>
      </footer>
    </div>
    <!-- 英語ver -->
    <div v-if="getLanguage == '中文'">
      <footer class="footer">
        <div class="footer_in">
          <div class="footer_1">
            <p>
              <span class="footer_serviceTtl">睡眠偏差値® for Biz</span>
              <span class="footer_serviceUrl">suiminhensachi.com</span>
            </p>
          </div>
          <div class="footer_2">
            <ul class="footer_nav">
              <li class="footer_navItem" v-on:click="toTermPath">
                <a>使用条款</a>
              </li>
            </ul>
          </div>
          <div class="footer_3">
            <dl>
              <dt>管理公司</dt>
              <dd>
                <a href="https://brain-sleep.com/"
                  ><img
                    src="../assets/bs_logo.svg"
                    class="footer_bslogoImg"
                    alt="BRAIN SLEEP"
                /></a>
              </dd>
            </dl>
          </div>
        </div>
      </footer>
    </div>
    <!-- 中国語ver -->
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { mapGetters } from "vuex";
import advices from "../assets/advices";
import advicesEn from "../assets/advicesEn";
import advicesCh from "../assets/advicesCh";
import VueApexCharts from "vue-apexcharts";
import data2020 from "./data_2020.json";
import data2021 from "./data_2021.json";
import data2022 from "./data_2022.json";
import data2025 from "./data_2025.json";
import Loading from "../components/Loading";

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);
export default {
  // eslint-disable-next-line
  beforeRouteEnter(to, from, next) {
    switch (from["path"]) {
      case "/":
        next({ path: "/mytop" });
        break;
      default:
        next();
    }
  },
  created() {
    // eslint-disable-next-line
    if (this.getLanguage == "日本語") {
      // eslint-disable-next-line
      this.advices = advices;
    } else if (this.getLanguage == "English") {
      // eslint-disable-next-line
      this.advices = advicesEn;
    } else if (this.getLanguage == "中文") {
      // eslint-disable-next-line
      this.advices = advicesCh;
    }

    // eslint-disable-next-line
    if (this.$route.params["from"] == "analytics") {
      this.diagnosisId = this.$route.params["diagnosisId"];
    } else {
      this.diagnosisId = this.getCurrentDiagnosisId;
    }

    var userInfo = this.getLoginUserInfo;
    this.gender = userInfo["gender"];
    this.age = userInfo["age"];
    this.occupation = userInfo["occupation"];
    this.familyIncome = userInfo["familyIncome"];
    this.personalIncome = userInfo["personalIncome"];
    this.marriedStatus = userInfo["marriedStatus"];
    this.children = userInfo["children"].split(",").map((e) => Number(e));
    this.height = userInfo["height"];
    this.weight = userInfo["weight"];
    this.prefecture = userInfo["prefecture"];
    this.mail = userInfo["mail"];
    this.mailConfirm = userInfo["mail"];
    this.workStyle = userInfo["workStyle"];
    this.wfhFrequency = userInfo["wfhFrequency"];

    // 回答スコアの取得
    axios
      .get("/diagnosis", {
        params: {
          diagnosisId: this.diagnosisId,
          beforePath: this.getBeforePath,
        },
        headers: { Authorization: this.getAccessToken },
        data: {},
      })
      .then((response) => {
        this.score = response.data;
        this.selfJobPerformance = response.data["selfJobPerformance"];
        setTimeout(this.isLoadedFunc, 10);
        this.getSleepQualityRankDesc();
        this.getSasRiskRankDesc();
        this.getProductivityRankDesc();
        this.getDayTimeSleepnessRankDesc();
        this.getMotivationRankDesc();
        // 回答時期によって呼び出し元データ変更
        if (response.data["created_at"] < "2021-05-14") {
          this.calcScore = data2020;
          this.series[0]["data"] = [
            356,
            422,
            792,
            1331,
            1758,
            2028,
            1764,
            1059,
            397,
            93,
          ];
          (this.scoreAverage = 70.89835074), (this.scoreSD = 11.34010895);
        } else if (response.data["created_at"] < "2023-04-01") {
          this.calcScore = data2021;
          this.series[0]["data"] = [
            331,
            473,
            789,
            1251,
            1807,
            2048,
            1739,
            1074,
            415,
            73,
          ];
          (this.scoreAverage = 70.63), (this.scoreSD = 11.12);
        } else if (response.data["created_at"] >= "2025-01-01") {
          this.calcScore = data2025;
          this.series[0]["data"] = [
            398,
            444,
            838,
            1375,
            1820,
            2030,
            1631,
            1027,
            437,
            52,
          ];
          (this.scoreAverage = 71.137), (this.scoreSD = 11.54);
        } else {
          this.calcScore = data2022;
          this.series[0]["data"] = [
            366,
            425,
            838,
            1315,
            1633,
            1922,
            1847,
            1112,
            422,
            68,
          ];
          (this.scoreAverage = 71.66), (this.scoreSD = 11.39);
        }
        this.updateDevGraph();
      })
      .catch((err) => {
        (this.errored = true), (this.error = err);
      });

    // 個人年収の取得
    switch (this.getLoginUserInfo["personalIncome"]) {
      case "200万円未満":
        this.personalIncome = 200;
        break;
      case "200～400万円未満":
        this.personalIncome = 400;
        break;
      case "400～600万円未満":
        this.personalIncome = 600;
        break;
      case "600～800万円未満":
        this.personalIncome = 800;
        break;
      case "800～1000万円未満":
        this.personalIncome = 1000;
        break;
      case "1000～1200万円未満":
        this.personalIncome = 1200;
        break;
      case "1200～1500万円未満":
        this.personalIncome = 1500;
        break;
      case "1500～2000万円未満":
        this.personalIncome = 2000;
        break;
      case "2000万円以上":
        this.personalIncome = 2000;
        break;
      default:
        this.personalIncome = 0;
    }
  },
  data() {
    return {
      fromPath: "",
      isLoaded: false,
      diagnosisId: 0,
      calcScore: data2020,
      score: "", // スコアデータ
      devRange: [30, 40, 50, 60, 70], // 偏差値境界
      rank: 100, // 全国順位
      rankPopulation: 10000, // 順位の最大値
      advices: advices, // アドバイスデータ
      averageSleepTime: 410, // 睡眠時間（分）（全国平均
      averageSleepnessTime: 3, // 日中の眠気を感じる時間（時）（全国平均）
      selfJobPerformance: 0, // 仕事の出来の100%評価
      personalIncome: 0, // 個人の年収
      currentLanguage: "",
      dist: "",
      chartOptions: {
        chart: {
          id: "devChart",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          categories: [
            "~30",
            "~35",
            "~40",
            "~45",
            "~50",
            "~55",
            "~60",
            "~65",
            "~70",
            "70~",
          ], // 偏差値グラフX軸目盛
        },
        // eslint-disable-next-line no-unused-vars
        colors: ["#ccccff"],
      },
      series: [
        {
          name: "人数",
          data: [331, 473, 789, 1251, 1807, 2048, 1739, 1074, 415, 73], // 偏差値人数分布
        },
      ],
      sleepQualityRankDescVarible: "",
      sasRiskRankDescVarible: "",
      dayTimeSleepnessRankDescVarible: "",
      productivityRankDescVarible: "",
      motivationRankDescVarible: "",
      scoreAverage: 0,
      scoreSD: 0,
      endReportUrl: "",
    };
  },
  methods: {
    getSleepQualityRankDesc() {
      var sleepQuality = this.score["sleepQuality"];
      switch (true) {
        case 66 <= sleepQuality:
          this.sleepQualityRankDescVarible = this.advices.categories[0];
          break;
        case 61 <= sleepQuality && sleepQuality < 66:
          this.sleepQualityRankDescVarible = this.advices.categories[1];
          break;
        case 50 <= sleepQuality && sleepQuality < 61:
          this.sleepQualityRankDescVarible = this.advices.categories[2];
          break;
        case sleepQuality < 50:
          this.sleepQualityRankDescVarible = this.advices.categories[3];
          break;
        default:
          this.sleepQualityRankDescVarible = this.advices.categories[1];
      }
    },
    ordinal(n) {
      var result;
      var s1 = +("" + n).slice(-1);
      var s2 = +("" + n).slice(-2);
      if (s2 >= 11 && s2 <= 13) {
        result = n + "th";
      } else if (s1 === 1) {
        result = n + "st";
      } else if (s1 === 2) {
        result = n + "nd";
      } else if (s1 === 3) {
        result = n + "rd";
      } else {
        result = n + "th";
      }
      return result;
    },
    getSasRiskRankDesc() {
      var sasRisk = this.score["sasRisk"];
      switch (true) {
        case 11 <= sasRisk:
          this.sasRiskRankDescVarible = this.advices.categories[0];
          break;
        case 9 <= sasRisk && sasRisk < 11:
          this.sasRiskRankDescVarible = this.advices.categories[1];
          break;
        case 6 <= sasRisk && sasRisk < 9:
          this.sasRiskRankDescVarible = this.advices.categories[2];
          break;
        case sasRisk < 6:
          this.sasRiskRankDescVarible = this.advices.categories[3];
          break;
        default:
          this.sasRiskRankDescVarible = this.advices.categories[1];
      }
    },
    getProductivityRankDesc() {
      var todaiPerformance = this.score["todaiPerformance"];
      switch (true) {
        case 100 <= todaiPerformance:
          this.productivityRankDescVarible = this.advices.categories[0];
          break;
        case 80 <= todaiPerformance && todaiPerformance < 100:
          this.productivityRankDescVarible = this.advices.categories[1];
          break;
        case 61 <= todaiPerformance && todaiPerformance < 80:
          this.productivityRankDescVarible = this.advices.categories[2];
          break;
        case todaiPerformance < 61:
          this.productivityRankDescVarible = this.advices.categories[3];
          break;
        default:
          this.productivityRankDescVarible = this.advices.categories[1];
      }
    },
    getDayTimeSleepnessRankDesc() {
      var daytimeSleepiness = this.score["daytimeSleepiness"];
      switch (true) {
        case 33 <= daytimeSleepiness:
          this.dayTimeSleepnessRankDescVarible = this.advices.categories[0];
          break;
        case 29 <= daytimeSleepiness && daytimeSleepiness < 33:
          this.dayTimeSleepnessRankDescVarible = this.advices.categories[1];
          break;
        case 19 <= daytimeSleepiness && daytimeSleepiness < 29:
          this.dayTimeSleepnessRankDescVarible = this.advices.categories[2];
          break;
        case daytimeSleepiness < 19:
          this.dayTimeSleepnessRankDescVarible = this.advices.categories[3];
          break;
        default:
          this.dayTimeSleepnessRankDescVarible = this.advices.categories[1];
      }
    },
    getMotivationRankDesc() {
      var motivationWorkingStyle = this.score["motivationWorkingStyle"];
      switch (true) {
        case 76 <= motivationWorkingStyle:
          this.motivationRankDescVarible = this.advices.categories[0];
          break;
        case 67 <= motivationWorkingStyle && motivationWorkingStyle < 76:
          this.motivationRankDescVarible = this.advices.categories[1];
          break;
        case 29 <= motivationWorkingStyle && motivationWorkingStyle < 67:
          this.motivationRankDescVarible = this.advices.categories[2];
          break;
        case motivationWorkingStyle < 29:
          this.motivationRankDescVarible = this.advices.categories[3];
          break;
        default:
          this.motivationRankDescVarible = this.advices.categories[1];
      }
    },
    toTermPath() {
      this.$router.push("/terms");
    },
    ReturnScoreRank(score, calcArray) {
      var i, thisrank, array_length;
      thisrank = 1;
      array_length = calcArray.length;
      var roundedScore = Math.round(score);
      for (i = 0; i < array_length; i++) {
        if (calcArray[i] - roundedScore > 0) {
          thisrank++;
        }
      }
      return thisrank;
    },
    updateDevGraph() {
      const colorsArr = this.devGraphLabelColors;
      const devGraphIndex = this.devGraphIndex;
      this.chartOptions = {
        chart: {
          toolbar: {
            show: false,
          },
        },
        colors: [
          // eslint-disable-next-line no-unused-vars
          function({ value, seriesIndex, dataPointIndex, w }) {
            // ハイライトするindex
            if (dataPointIndex == devGraphIndex) {
              return "#ff6600";
            } else {
              return "#ffcc99";
            }
          },
        ],
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            return val.toLocaleString();
          },
          distributed: true,
          offsetY: -20,
          style: {
            colors: colorsArr,
          },
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: "top",
            },
          },
        },
        xaxis: {
          categories: this.chartOptions.xaxis.categories,
          labels: {
            offsetY: -4,
            style: {
              cssClass: "result_devGraphXaxis",
            },
          },
        },
        yaxis: {
          labels: {
            formatter: (val) => {
              return val;
            },
          },
        },
      };
    },
    isLoadedFunc() {
      this.isLoaded = true;
    },
    toSleepTestPath() {
      if (this.getLoginUserInfo.report_end_url == "表示する") {
        this.$router.push("/sleepTestTop");
      } else {
        window.open(this.getLoginUserInfo.report_end_url, "_blank");
      }
    },
    toSleepLinkPath() {
      window.open(this.getLoginUserInfo.report_end_link_url, "_blank");
    },
  },
  computed: {
    ...mapGetters([
      "getCurrentDiagnosisId",
      "getAccessToken",
      "getLoginUserInfo",
      "getBeforePath",
      "getLanguage",
    ]),
    returnLanguage() {
      return this.getLanguage;
    },
    //  平均睡眠時間
    sleepTime() {
      return this.score["averageSleepTime"];
    },
    //  日中眠気を感じる時間
    sleepnessTime() {
      return this.score["totalSleepinessTime"];
    },
    // 経済損失額（単位:万円）
    EconomicLoss() {
      return Math.round(
        this.personalIncome * ((100 - this.selfJobPerformance) / 100)
      );
    },
    returnSleepQualityDesc() {
      return this.sleepQualityRankDescVarible;
    },
    // 合計スコアの順位
    totalScoreRank() {
      return this.ReturnScoreRank(this.scoreTotal, this.calcScore["total"]);
    },
    // 「睡眠の質」順位
    sleepQualityRanking() {
      return this.ReturnScoreRank(
        this.score["sleepQualityCoverted"],
        this.calcScore["sleep"]
      );
    },
    // 「SASリスク」順位
    sasRiskRanking() {
      return this.ReturnScoreRank(
        this.score["sasRiskConverted"],
        this.calcScore["sasRisk"]
      );
    },
    // 「生産性」順位
    productivityRanking() {
      return this.ReturnScoreRank(
        this.score["todaiPerformanceConverted"],
        this.calcScore["todaiPerformance"]
      );
    },
    // 「日中の眠気」順位
    daytimeSleepnessRanking() {
      return this.ReturnScoreRank(
        this.score["daytimeSleepinessConverted"],
        this.calcScore["daytymeSleepiness"]
      );
    },
    // 「モチベーション・働き方」順位
    motivationRanking() {
      return this.ReturnScoreRank(
        this.score["motivationWorkingStyleCoverted"],
        this.calcScore["motivationWorkingStyle"]
      );
    },
    //  ショートスリーパーか?
    isShortSleeper() {
      return this.score["isShortSleeper"];
    },
    //  SASか?
    hasSas() {
      var hasSas = 0;
      if (this.score["hasSleepDisorder"] == 1) {
        hasSas = 1;
      }
      return hasSas;
    },
    //  睡眠障害があるか?
    hasSleepDisorder() {
      var hasSleepDisorder = 0;
      if (this.score["hasSleepDisorder"] != 0) {
        hasSleepDisorder = 1;
      }
      return hasSleepDisorder;
    },
    devIndex() {
      return this.devRange.filter((e) => this.deviationValue <= e).length;
    },
    deviationValue() {
      return ((this.scoreTotal - this.scoreAverage) / this.scoreSD) * 10 + 50;
    },
    scoreTotal() {
      return (
        this.score["sleepQualityCoverted"] +
        this.score["sasRiskConverted"] +
        this.score["todaiPerformanceConverted"] +
        this.score["daytimeSleepinessConverted"] +
        this.score["motivationWorkingStyleCoverted"]
      );
    },
    sleepQualityRank() {
      var sleepQuality = this.score["sleepQuality"];
      switch (true) {
        case 66 <= sleepQuality:
          return "A";
        case 61 <= sleepQuality && sleepQuality < 66:
          return "B";
        case 50 <= sleepQuality && sleepQuality < 61:
          return "C";
        case sleepQuality < 50:
          return "D";
        default:
          return "B";
      }
    },
    sasRiskRank() {
      var sasRisk = this.score["sasRisk"];
      switch (true) {
        case 11 <= sasRisk:
          return "A";
        case 9 <= sasRisk && sasRisk < 11:
          return "B";
        case 6 <= sasRisk && sasRisk < 9:
          return "C";
        case sasRisk < 6:
          return "D";
        default:
          return "B";
      }
    },
    productivityRank() {
      var todaiPerformance = this.score["todaiPerformance"];
      switch (true) {
        case 100 <= todaiPerformance:
          return "A";
        case 80 <= todaiPerformance && todaiPerformance < 100:
          return "B";
        case 61 <= todaiPerformance && todaiPerformance < 80:
          return "C";
        case todaiPerformance < 61:
          return "D";
        default:
          return "B";
      }
    },
    daytimeSleepnessRank() {
      var daytimeSleepiness = this.score["daytimeSleepiness"];
      switch (true) {
        case 33 <= daytimeSleepiness:
          return "A";
        case 29 <= daytimeSleepiness && daytimeSleepiness < 33:
          return "B";
        case 19 <= daytimeSleepiness && daytimeSleepiness < 29:
          return "C";
        case daytimeSleepiness < 19:
          return "D";
        default:
          return "B";
      }
    },
    motivationRank() {
      var motivationWorkingStyle = this.score["motivationWorkingStyle"];
      switch (true) {
        case 76 <= motivationWorkingStyle:
          return "A";
        case 67 <= motivationWorkingStyle && motivationWorkingStyle < 76:
          return "B";
        case 29 <= motivationWorkingStyle && motivationWorkingStyle < 67:
          return "C";
        case motivationWorkingStyle < 29:
          return "D";
        default:
          return "B";
      }
    },
    sleepTimeDifference() {
      const dif = this.sleepTime - this.averageSleepTime;
      const sign = dif > 0 ? "+" : "";
      return sign + dif;
    },
    sleepnessTimeDiffernce() {
      const dif = this.sleepnessTime - this.averageSleepnessTime;
      const sign = dif > 0 ? "+" : "";
      return sign + dif;
    },
    devGraphIndex() {
      const devGraphRange = [30, 35, 40, 45, 50, 55, 60, 65, 70]; // 偏差値境界
      const index = devGraphRange.filter((e) => this.deviationValue >= e)
        .length;
      return index;
    },
    devGraphLabelColors() {
      const labelTxtColor = "#aaa";
      const labelEmTxtColor = "#ff6600";
      const length = 9;
      const colors = new Array(length).fill(labelTxtColor);
      colors.splice(this.devGraphIndex, 0, labelEmTxtColor);
      return colors;
    },
  },
  watch: {
    returnLanguage() {
      // eslint-disable-next-line
      if (this.getLanguage == "日本語") {
        // eslint-disable-next-line
        this.advices = advices;
      } else if (this.getLanguage == "English") {
        // eslint-disable-next-line
        this.advices = advicesEn;
      } else if (this.getLanguage == "中文") {
        // eslint-disable-next-line
        this.advices = advicesCh;
      }
      this.getSleepQualityRankDesc();
      this.getSasRiskRankDesc();
      this.getProductivityRankDesc();
      this.getDayTimeSleepnessRankDesc();
      this.getMotivationRankDesc();
    },
  },
  components: {
    Loading,
  },
};
</script>

<style scoped lang="scss">
$xs: "320px";
$sm: "480px";
$md: "800px";
$lg: "1024px";
html {
  background-color: #5592c6;
}

.v-application p {
  margin-bottom: 0;
}
.result {
  background-color: #5592c6;
  color: #fff;
  overflow: hidden;
  height: calc(100vh - 114px);
  &.is-loaded {
    overflow: auto;
    height: auto;
  }
  &.is-loaded &_loading {
    opacity: 0;
    transition: opacity 1s ease;
    pointer-events: none;
  }
  &_headerLogo {
    text-align: center;
  }
  &_headerLogoImg {
    width: 180px;
  }
  &_top {
    position: relative;
    padding: 24px;
    @media screen and (max-width: $md) {
      padding: 0;
    }
    &::after {
      content: "";
      width: 100%;
      height: 200px;
      background-color: #3c67a2;
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 1;
      @media screen and (max-width: $md) {
        display: none;
      }
    }
  }
  &_topTtl {
    font-size: 28px;
    text-align: center;
  }
  &_summary {
    display: flex;
    justify-content: space-between;
    padding: 16px 72px 8px;
    align-items: center;
    @media screen and (max-width: $md) {
      display: block;
      padding: 24px 0;
    }
    @media screen and (max-width: $sm) {
      display: block;
      padding: 12px 0 24px;
    }
  }
  &_topIn {
    background-color: #fff;
    color: #3c67a2;
    max-width: 1080px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 4px;
    margin-top: 36px;
    position: relative;
    z-index: 2;
    @media screen and (max-width: $md) {
      border-radius: 0;
    }
    @media screen and (max-width: $sm) {
      padding: 16px;
      margin-top: 16px;
    }
  }
  &_topTtl {
    letter-spacing: 0.1em;
  }
  &_dev {
    text-align: center;
    padding-right: 60px;
    @media screen and (max-width: $md) {
      padding-right: 0;
    }
  }
  &_devTtl {
    display: block;
    font-size: 20px;
  }
  &_devTxt {
    font-size: 90px;
    line-height: 1;
  }
  &_devDesc {
    background-color: #ebf6fd;
    padding: 24px;
    border-radius: 6px;
    position: relative;
    max-width: 186px;
    @media screen and (max-width: $lg) {
      max-width: 100%;
      display: inline-block;
      text-align: center;
      padding: 12px 24px;
    }
    &::after {
      content: "";
      width: 24px;
      height: 24px;
      border-radius: 4px;
      background-color: #ebf6fd;
      position: absolute;
      right: -8px;
      top: 32px;
      transform: rotate(45deg);
      @media screen and (max-width: $lg) {
        left: 50%;
        right: auto;
        bottom: -11px;
        top: auto;
        margin-left: -8px;
      }
    }
  }
  &_devGraph {
    display: flex;
    align-items: center;
    @media screen and (max-width: $lg) {
      display: block;
      text-align: center;
      margin-top: 16px;
    }
  }
  &_devGraphDesc1 {
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.05em;
    @media screen and (max-width: $lg) {
      font-size: 14px;
    }
  }
  &_devGraphDesc2 {
    font-size: 14px;
    @media screen and (max-width: $lg) {
      font-size: 12px;
    }
  }
  &_devGraphCont {
    margin-bottom: -20px;
  }
  &_devGraphXaxis {
    letter-spacing: 0.05em;
  }
  &_chart {
    width: 500px;
    height: 200px;
    @media screen and (max-width: $md) {
      width: auto;
    }
  }
  &_rank {
    display: flex;
    padding: 24px 72px;
    border-top: solid 1px #ccc;
    @media screen and (max-width: $md) {
      display: block;
      padding: 24px 12px;
    }
  }
  &_rankIn {
    display: flex;
    @media screen and (max-width: $md) {
      display: block;
    }
    @media screen and (max-width: $sm) {
      padding-left: 0;
      border-left: 0;
    }
  }
  &_rankTxt {
    margin-left: 64px;
    @media screen and (max-width: $md) {
      margin-left: 0;
      margin-top: 16px;
    }
  }
  &_scoreTtl,
  &_rankTtl {
    display: block;
    font-size: 18px;
    line-height: 1;
    font-weight: bold;
    margin-bottom: 4px;
    @media screen and (max-width: $md) {
      font-size: 14px;
    }
  }
  &_scoreCont,
  &_rankCont {
    display: inline-block;
    vertical-align: middle;
    padding-left: 16px;
    line-height: 1;
  }
  &_scoreIndex,
  &_rankCategory {
    display: inline-block;
    vertical-align: middle;
  }
  &_scoreIndexTxt,
  &_rankCategoryTxt {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 64px;
    height: 64px;
    border-radius: 32px;
    background-color: #3c67a2;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.05em;
    line-height: 1;
    @media screen and (max-width: $md) {
      width: 54px;
      height: 54px;
    }
  }
  &_scoreNum,
  &_rankNum {
    font-weight: 500;
    font-size: 42px;
    color: #3c67a2;
    line-height: 1;
    @media screen and (max-width: $md) {
      font-size: 32px;
    }
  }
  &_scoreSuffix,
  &_rankSuffix {
    font-weight: 600;
    font-size: 32px;
    @media screen and (max-width: $md) {
      font-size: 24px;
    }
  }
  &_scoreSlash,
  &_rankSlash {
    color: #999;
    font-size: 24px;
    margin: 0px 4px;
  }
  &_scoreAllNum,
  &_populationNum {
    font-weight: 500;
    font-size: 32px;
    color: #999;
    @media screen and (max-width: $md) {
      font-size: 24px;
    }
  }
  &_scoreAllSuffix,
  &_populationSuffix {
    font-size: 24px;
    color: #999;
    font-weight: 500;
    @media screen and (max-width: $md) {
      font-size: 16px;
    }
  }
  &_advice {
    display: flex;
    padding: 42px 72px;
    border-top: solid 1px #ccc;
    @media screen and (max-width: $md) {
      display: block;
      padding: 12px;
      text-align: center;
    }
  }
  &_adviceImg {
    width: 210px;
    height: 210px;
    flex-shrink: 1;
    @media screen and (max-width: $lg) {
      img {
        width: 100%;
      }
    }
    @media screen and (max-width: $md) {
      width: 120px;
      height: 120px;
      margin: 0 auto;
    }
  }
  &_adviceCont {
    padding-left: 24px;
    flex-shrink: 2;
    @media screen and (max-width: $md) {
      padding: 0;
      margin-top: 12px;
    }
  }
  &_adviceTxt {
    margin-top: 12px;
    line-height: 1.75;
    @media screen and (max-width: $lg) {
      text-align: justify;
      font-size: 14px;
    }
  }
  &_adviser {
    letter-spacing: 0.02em;
  }
  &_adviserSub {
    display: block;
    font-size: 14px;
    @media screen and (max-width: $lg) {
      font-size: 12px;
    }
  }
  &_adviserTtl {
    font-weight: bold;
    font-size: 20px;
    @media screen and (max-width: $lg) {
      font-size: 18px;
    }
  }
  &_adviserTtlSm {
    font-size: 14px;
    margin: 0 0.2em;
    display: inline-block;
    vertical-align: baseline;
  }
  &_detail {
    padding: 72px 24px;
    background-color: #3c67a2;
    @media screen and (max-width: $sm) {
      padding: 36px 16px 16px;
    }
  }
  &_detailIn {
    max-width: 1080px;
    margin: 0 auto;
    background-color: #fff;
    padding: 54px;
    border-radius: 4px;
    margin-top: 36px;
    @media screen and (max-width: $sm) {
      padding: 16px;
    }
  }
  &_detailTtl {
    text-align: center;
    font-size: 28px;
    letter-spacing: 0.1em;
  }
  &_detailList {
    list-style-type: none;
    padding: 0;
  }
  &_detailListItem {
    display: flex;
    align-items: center;
    & + & {
      margin-top: 54px;
    }
    @media screen and (max-width: $lg) {
      flex-wrap: wrap;
    }
  }
  &_detailListItem-SAS {
    @media screen and (min-width: $md) {
      align-items: flex-start;
      justify-content: space-between;
    }
  }
  &_detailRank {
    width: 200px;
    border-radius: 4px;
    overflow: hidden;
    flex: 0 0 200px;
    @media screen and (max-width: $md) {
      flex: 0 0 50%;
    }
  }
  &_detailRank-A {
    .result_detailRankTtl {
      background-color: #3c67a2;
    }
    .result_detailRankData {
      background-color: #6195d1;
    }
  }
  &_detailRank-B {
    .result_detailRankTtl {
      background-color: #3c9aa2;
    }
    .result_detailRankData {
      background-color: #61d1c4;
    }
  }
  &_detailRank-C {
    .result_detailRankTtl {
      background-color: #3ca257;
    }
    .result_detailRankData {
      background-color: #72d161;
    }
  }
  &_detailRank-D {
    .result_detailRankTtl {
      background-color: #db2e2e;
    }
    .result_detailRankData {
      background-color: #f84949;
    }
  }
  &_detailRankTtl {
    text-align: center;
    font-size: 18px;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1.4;
    font-weight: 600;
  }
  &_detailRankTxt {
    display: block;
    font-size: 80px;
    font-weight: 500;
    @media screen and (max-width: $md) {
      line-height: 1.2;
    }
  }
  &_detailRanking {
    font-size: 14px;
  }
  &_detailRankData {
    text-align: center;
    height: 155px;
    @media screen and (max-width: $md) {
      height: 135px;
    }
  }
  &_sas {
    display: flex;
    margin-top: 8px;
    @media screen and (max-width: $lg) {
      display: block;
    }
  }
  &_detailDesc {
    margin-left: 24px;
    // max-width: 720px;
    @media screen and (max-width: $lg) {
      order: 3;
      margin: 16px 0 0 0;
    }
    & & {
      margin-left: 0;
    }
  }
  &_detailDescSub {
    color: #666;
    font-size: 12px;
    line-height: 1.6;
  }
  &_detailDescTxt {
    color: #333;
    font-size: 15px;
    line-height: 1.75;
    text-align: justify;
    @media screen and (max-width: $md) {
      font-size: 14px;
    }
  }
  &_detailDescSASBlock {
    @media screen and (min-width: 640px) {
      display: grid;
      grid-template-columns: 1fr 180px;
      grid-template-rows: 170px 1fr;
    }
    @media screen and (min-width: $md) {
      display: grid;
      grid-template-columns: 1fr 200px;
      grid-template-rows: 120px 1fr;
    }
  }
  &_detailListItem-SAS &_detailDesc {
    @media screen and (min-width: 640px) {
      grid-column: 1 / 3;
      grid-row: 2 / 3;
    }
    @media screen and (min-width: $md) {
      grid-column: 1 / 2;
      grid-row: 2 / 3;
      padding-right: 1em;
      //  margin: 0;
    }
  }
  &_detail-sas {
    order: 3;
  }
  &_detailDescSAS {
    margin-top: 1em;
    line-height: 1.75;
    @media screen and (min-width: $sm) {
      grid-column: 1 / 2;
      grid-row: 1 / 2;
      padding-right: 1em;
    }
    @media screen and (min-width: $lg) {
      margin-left: 24px;
    }
  }
  &_detailDescSASTxt {
    color: #000;
    font-size: 14px;
    @media screen and (min-width: $md) {
      font-size: 15px;
    }
  }
  &_detailDescSASTtl {
    color: #3c67a2;
    font-weight: bold;
    font-size: 14px;
    @media screen and (min-width: $md) {
      font-size: 16px;
    }
  }
  &_detailDescSASClinic {
    color: #3c67a2;
    font-weight: bold;
    padding-left: 1em;
    @media screen and (min-width: 640px) {
      padding-left: 0;
    }
  }
  &_detailDescSASClinicName {
    display: block;
    font-size: 14px;
    line-height: 1;
    @media screen and (min-width: $md) {
      font-size: 16px;
    }
  }
  &_detailDescSASClinicSAS {
    font-size: 12px;
    @media screen and (min-width: $md) {
      font-size: 14px;
    }
  }
  &_detailDescSASClinicOnline {
    display: inline-block;
    line-height: 1;
    padding: 2px;
    background-color: #3c67a2;
    color: #fff;
    font-size: 12px;
    margin-left: 0.2em;
    @media screen and (min-width: $md) {
      font-size: 14px;
    }
  }
  &_detailDescSASLink {
    color: #3c67a2;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 0.5em;
    @media screen and (min-width: 640px) {
      display: block;
      grid-column: 2 / 3;
      grid-row: 1 / 2;
    }
    @media screen and (min-width: $md) {
      grid-column: 2 / 3;
      grid-row: 1 / 3;
    }
  }
  &_detailDescSASClinicImg {
    max-width: 140px;
    @media screen and (min-width: $md) {
      max-width: 100%;
    }
  }
  &_detailDescSASClinicLink {
    display: block;
    font-size: 14px;
    font-weight: bold;
    border: solid 1px #3c67a2;
    border-radius: 4px;
    margin-top: 4px;
    padding: 6px;
    text-align: center;
    line-height: 1;
    @media screen and (min-width: $md) {
      transition: opacity 0.2s ease;
      &:hover {
        opacity: 0.7;
      }
    }
  }
  &_detailSub {
    color: #000;
    flex: 0 0 200px;
    padding-left: 16px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    @media screen and (max-width: $lg) {
      order: 2;
      flex: 0 0 50%;
    }
    > div {
      position: relative;
      z-index: 2;
    }
    img {
      max-width: 100%;
    }
    &::before {
      content: "";
      position: absolute;
      display: block;
      width: 160px;
      height: 160px;
      background-color: #ebf6fd;
      border-radius: 100px;
      z-index: 1;
    }
    &.noBg::before {
      display: none;
    }
  }
  &_detailSub-sas {
    @media screen and (max-width: $lg) {
      display: none;
    }
  }
  &_detailSub-sas2 {
    display: none;
    @media screen and (max-width: $lg) {
      display: block;
    }
  }
  &_detailSubDif {
    display: block;
    font-size: 14px;
    letter-spacing: 0.05em;
    text-align: center;
    background-color: #f60;
    color: #fff;
    border-radius: 4px;
    padding: 4px 8px;
    font-weight: bold;
    position: relative;
    z-index: 2;
    margin-top: 8px;
    &::after {
      content: "";
      width: 10px;
      height: 10px;
      border-radius: 2px;
      position: absolute;
      left: 50%;
      margin-left: -8px;
      top: -4px;
      transform: rotate(45deg);
      background-color: #f60;
      z-index: 0;
    }
  }
  &_detailSubTtl {
    font-weight: bold;
    color: #666;
    display: block;
    letter-spacing: 0.05em;
    margin-bottom: 4px;
    @media screen and (max-width: $md) {
      font-size: 14px;
    }
  }
  &_detailSubCont {
    font-size: 28px;
    text-align: center;
    display: block;
    color: #3c67a2;
    margin-bottom: 4px;
    font-weight: bold;
  }
  &_articles {
    background-color: #f3f3f3;
    padding: 72px;
    @media screen and (max-width: $sm) {
      padding: 32px 16px;
    }
  }
  &_articlesTtl {
    text-align: center;
    font-size: 28px;
    color: #3c67a2;
    letter-spacing: 0.1em;
    @media screen and (max-width: $lg) {
      font-size: 18px;
    }
  }
  &_articlesList {
    list-style-type: none;
    padding: 0;
    max-width: 1080px;
    // margin: 36px auto;
    margin: 0 auto 36px auto;
    border-radius: 4px;
    display: flex;
    flex-wrap: wrap;
    @media screen and (max-width: $md) {
      margin: 24px auto;
    }
  }
  &_article {
    width: 50%;
    padding: 16px;
    @media screen and (max-width: $md) {
      padding: 8px 0;
      width: 100%;
    }
  }
  &_articleLink {
    background-color: #fff;
    display: flex;
    border: solid 2px #3c67a2;
    border-radius: 6px;
    overflow: hidden;
    text-decoration: none;
    position: relative;
    &::after {
      content: "";
      width: 12px;
      height: 12px;
      border-top: solid 3px #aaa;
      border-right: solid 3px #aaa;
      transform: rotate(45deg);
      position: absolute;
      right: 24px;
      top: 50%;
      margin-top: -6px;
    }
    &:hover {
      opacity: 0.6;
    }
  }
  &_articleThumb {
    width: 158px;
    height: 90px;
    overflow: hidden;
    @media screen and (max-width: $md) {
      width: 122px;
    }
    img {
      height: 100%;
      max-width: auto;
      @media screen and (max-width: $md) {
        transform: translateX(-18px);
      }
    }
  }
  &_articleTtl {
    color: #3c67a2;
    font-size: 18px;
    font-weight: bold;
    // margin-top: 4px;
    display: block;
    @media screen and (max-width: $lg) {
      font-size: 14px;
    }
  }
  &_articleTxt {
    color: #808080;
    font-size: 16px;
    // padding-left: 32px;
    padding-left: 20px;
    @media screen and (max-width: $lg) {
      padding-left: 16px;
      padding-right: 48px;
      flex: 1;
    }
  }
  &_articleNum {
    display: block;
    color: #a8a8a8;
    font-weight: bold;
    line-height: 1;
  }
  &_articleLink {
    align-items: center;
  }
  &_articlesLink {
    background: #fff url(../assets/img_result_right.svg) no-repeat;
    background-position: 60% center;
    color: #5592c6;
    max-width: 1080px;
    border-radius: 4px;
    margin: 48px auto;
    display: flex;
    align-items: center;
    font-size: 24px;
    padding: 24px;
    justify-content: flex-start;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
    position: relative;
    @media screen and (max-width: $md) {
      display: block;
      background: #fff;
      margin: 16px auto;
      text-align: center;
    }
  }
  &_articlesLink_pr {
    background: #fff;
    background-position: 60% center;
    color: #5592c6;
    max-width: 1080px;
    border-radius: 4px;
    margin: 48px auto;
    display: flex;
    align-items: center;
    font-size: 24px;
    padding: 24px;
    justify-content: center;
    flex-direction: column;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
    position: relative;
    @media screen and (max-width: $md) {
      display: block;
      background: #fff;
      margin: 16px auto;
      text-align: center;
    }
  }
  &_articlesLinkTtl {
    padding: 24px 24px 24px 64px;
    margin-bottom: 0;
    font-weight: bold;
    font-size: 24px;
    @media screen and (max-width: $lg) {
      font-size: 16px;
      padding: 0;
      font-size: 14px;
      margin-bottom: 16px;
    }
  }
  &_articlesLinkTtl_pr {
    margin-bottom: 0;
    font-weight: bold;
    font-size: 24px;
    @media screen and (max-width: $lg) {
      font-size: 16px;
      padding: 0;
      font-size: 14px;
      margin-bottom: 16px;
    }
  }
  &_articlesLinkTxt {
    margin-bottom: 0;
    @media screen and (min-width: $lg) {
      padding-left: 80px;
    }
  }
  &_articlesLinkTxt_pr {
    margin-bottom: 0;
    font-size: 16px;
    color: black;
  }
  &_articlesLinkHref {
    display: block;
    &:hover {
      opacity: 0.7;
    }
    @media screen and (max-width: $md) {
      margin-top: 16px;
    }
  }
  &_articlesLinkImg {
    width: 300px;
    display: block;
    @media screen and (max-width: $md) {
      margin: 0 auto;
    }
  }
}
.footer {
  background-color: #f3f3f3;
}
/* 各項目の判定区分 */
.result_rankingExplanation {
  background-color: #f3f3f3;
  padding: 20px;
  margin-bottom: 54px;
  color: #3c67a2;
  @media screen and (max-width: $lg) {
    padding: 5px 0;
  }
}
.result_rankingExplanation p {
  text-align: center;
  font-size: 18px;
  line-height: 1.4;
  font-weight: 600;
  padding-bottom: 10px;
}
.result_rankingList {
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: $lg) {
    display: flex;
    flex-wrap: wrap;
    padding: initial !important;
  }
}
.result_rankingListItem {
  display: flex;
  width: 200px;
  height: 50px;
  margin: 0 10px;
  background-color: #fff;
  border-radius: 4px;
  border: solid 1px #ccc;
  @media screen and (max-width: $lg) {
    margin: 5px auto;
    width: 150px;
    box-sizing: border-box;
  }
}
.rankingRank {
  width: 50px;
  height: 100%;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  text-align: center;
  line-height: 50px;
  @media screen and (max-width: $lg) {
    font-size: 28px;
    font-weight: 500;
  }
}
.result_rankingRank-A {
  background-color: #3c67a2;
  color: #fff;
}
.result_rankingRank-B {
  background-color: #3c9aa2;
  color: #fff;
}
.result_rankingRank-C {
  background-color: #3ca257;
  color: #fff;
}
.result_rankingRank-D {
  background-color: #db2e2e;
  color: #fff;
}
.result_rankingText {
  text-align: center;
  width: 150px;
  height: 100%;
  line-height: 50px;
  @media screen and (max-width: $lg) {
    width: 110px;
  }
}
.result_rankingText span {
  color: #333;
  width: 100%;
  @media screen and (max-width: $lg) {
    font-size: 14px;
  }
}
.result_detailRanking {
  font-size: 14px;
  display: block;
  position: relative;
  top: -20px;
}
/* articles */
.result_articlesSubTtl {
  color: #3c67a2;
  font-size: 18px;
  font-weight: bold;
  // display: block;
  display: flex;
  align-items: center;
  max-width: 1080px;
  margin: auto;
  padding: 0 16px;
  @media screen and (max-width: $md) {
    font-size: 14px;
    padding: 0;
  }
}
.result_articlesLink_pr {
  padding: 30px;
}
.result_articlesSubTtl:after {
  border-top: 1px solid #3c67a2;
  content: "";
  flex-grow: 1;
}
.result_articlesSubTtl:before {
  margin-right: 1em;
}
.result_articlesSubTtl:after {
  margin-left: 1em;
}
.result_articlesSubTtl.half {
  max-width: 540px;
  width: 100%;
  @media screen and (max-width: $md) {
    max-width: 1080px;
  }
}
.result_articlesList.half {
  width: 100%;
  max-width: 540px;
  @media screen and (max-width: $md) {
    max-width: 1080px;
  }
}
.result_articlesSubTtl.half.left {
  margin-right: 0;
  @media screen and (max-width: $md) {
    margin-right: auto;
  }
}
.result_articlesSubTtl.half.right {
  margin-left: 0;
  @media screen and (max-width: $md) {
    margin-left: auto;
  }
}
.article-group {
  display: flex;
  @media screen and (max-width: $md) {
    display: block;
  }
}
.article-group .result_article {
  width: 100%;
}
.article-pair {
  width: 50%;
  @media screen and (max-width: $md) {
    width: 100%;
  }
}
.result_articlesList.left {
  margin-right: 0;
  @media screen and (max-width: $md) {
    margin-right: auto;
  }
}
.result_articlesList.right {
  margin-left: 0;
  @media screen and (max-width: $md) {
    margin-left: auto;
  }
}
h2.result_articlesTtl {
  padding-bottom: 36px;
}
</style>
